// on going code
import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { FiUploadCloud } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO, addDays } from "date-fns";
import { GiNetworkBars } from "react-icons/gi";
import { BsFillLuggageFill } from "react-icons/bs";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import axios from "axios";
import { RiFileEditFill } from "react-icons/ri";
import { IoIosMail } from "react-icons/io";
import { LuArrowBigRightDash } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import Loader from "../Loader/Loader";
import useMinimumLoading from "../hooks/Useminimumloading";
import { API_URL } from "../../Config";

const Bookings = () => {
  // Add this helper function at the top of your component, after the useState declarations
  const [mailLoading, setMailLoading] = useState(false);

  const [bookingTab, setBookingTab] = useState("upcoming");
  const formatDateForDisplay = (dateValue) => {
    if (!dateValue) return "";

    // If it's already a Date object
    if (dateValue instanceof Date) {
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, "0");
      const day = String(dateValue.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    // If it's a string
    if (typeof dateValue === "string") {
      // If it contains 'T' (ISO datetime), extract just the date part
      if (dateValue.includes("T")) {
        // Parse the date string and create a local date
        const date = new Date(dateValue);
        // Use local date methods to avoid timezone shift
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      // If it's already YYYY-MM-DD, return as is
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return dateValue;
      }
    }

    return dateValue;
  };
  const navigate = useNavigate();
  // const user = JSON.parse(localStorage.getItem("user"));
  const user = JSON.parse(localStorage.getItem("user") || "null") || null;
  const isAdmin = user?.role?.toLowerCase() === "admin";

  const [loading, setLoading] = useState(true);
  const showLoader = useMinimumLoading(loading);

  const [formMode, setFormMode] = useState("add");
  const [bookings, setBookings] = useState([]);
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [manualMode, setManualMode] = useState(false);
  const [manualProperty, setManualProperty] = useState("");

  const [deletePopup, setDeletePopup] = useState({
    open: false,
    bookingid: null,
  });
  const [editingBooking, setEditingBooking] = useState(null); // store booking being edited

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  const [formData, setFormData] = useState({
    country: "",
    state: "",
    city: "",
    gstnum: "",
    totpay: "",
    advpay: "",
    balpay: "",
    property: "",
    rooms: 0,
    guests: 0,
    bookingstatus: "Pending", // Add default
    paymentstatus: "Pending", // Add default
    inclusions: "",
    checkinHour: "12",
    checkinMinute: "00",
    checkinAmPm: "PM",
    checkoutHour: "11",
    checkoutMinute: "00",
    checkoutAmPm: "AM",
  });
  const [idproofFile, setidproofFile] = useState(null);
  const [executives, setExecutives] = useState([]);
  const [nameSuggestions, setNameSuggestions] = useState([]);
  const [showNameSuggestions, setShowNameSuggestions] = useState(false);
  const suggestionRef = useRef(null);
  const [showGstConfirm, setShowGstConfirm] = useState(false);
  const [pendingGstValue, setPendingGstValue] = useState(null);
  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        const res = await fetch(`${API_URL}/users`);
        const data = await res.json();
        setExecutives(data);
      } catch (err) {
        console.error("Error fetching executives:", err);
      }
    };

    fetchExecutives();
  }, []);
  // inclusive of GST
  const [isinclusive, setisinclusive] = useState(true);
  const b2c = Number(formData.btocprice || 0);
  const secdep = Number(formData.secdep || 0);
  let baseprice = 0;
  let cgst = 0;
  let sgst = 0;
  let total = 0;

  if (b2c > 0) {
    if (isinclusive) {
      // Price already includes GST
      baseprice = b2c / 1.18;
      const gstAmount = b2c - baseprice;
      cgst = gstAmount / 2;
      sgst = gstAmount / 2;
      total = b2c; //secdep
    } else {
      // Price does NOT include GST
      baseprice = b2c;
      cgst = baseprice * 0.09;
      sgst = baseprice * 0.09;
      total = baseprice + cgst + sgst; //secdep
    }
  }
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };
  const [worldData, setWorldData] = useState([]);

  useEffect(() => {
    // fetch from public/world.json
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => setWorldData(data))
      .catch((err) => console.error("Error loading world.json:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      // 🌍 Reset dependent dropdowns
      if (name === "country") {
        updated.state = "";
        updated.city = "";
      } else if (name === "state") {
        updated.city = "";
      }

      if (name === "proprice" || name === "checkin" || name === "checkout") {
        const checkin = updated.checkin;
        const checkout = updated.checkout;
        const proprice = parseFloat(updated.proprice) || 0;

        if (checkin && checkout && proprice > 0) {
          const checkinDate = new Date(checkin);
          const checkoutDate = new Date(checkout);
          const nights = Math.max(
            0,
            Math.round((checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)),
          );
          updated.btocprice = (nights * proprice).toFixed(2);
        }
      }

      // 💰 Auto-calculate balance when proprice or advance changes
      // if (name === "proprice" || name === "advpay") {
      //   const pro = parseFloat(updated.proprice) || 0;
      //   const advance = parseFloat(updated.advpay) || 0;
      //   updated.balpay = (pro - advance).toFixed(2);
      //   // const total = parseFloat(updated.proprice) || 0;
      //   // const advance = parseFloat(updated.advpay) || 0;
      //   // updated.balpay = (total - advance).toFixed(2);
      // }
      return updated;
    });
    if (name === "firstname") {
      // Clear any existing timeout
      if (window.suggestionTimeout) {
        clearTimeout(window.suggestionTimeout);
      }

      // Set new timeout for debounce
      window.suggestionTimeout = setTimeout(() => {
        fetchNameSuggestions(value);
      }, 300); // Wait 300ms after user stops typing
    }
  };

  // Find selected country object
  const selectedCountry = worldData.find((c) => c.name === formData.country);

  // Extract states
  const states = selectedCountry?.states || [];

  // Find selected state object
  const selectedState = states.find((s) => s.name === formData.state);

  // Extract cities
  const cities = selectedState?.cities || [];
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setidproofFile(file); // save selected file
    }
  };
  const fileInputRef = useRef(null);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  // put this near the top of your component (after useState for bookings)
  const fetchBookings = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/bookings`);
      const data = await res.json();
      setBookings(data);
    } catch (err) {
      console.error("Error fetching bookings:", err);
    } finally {
      setLoading(false); // hide loader after fetch
    }
  };

  // then call it in useEffect
  useEffect(() => {
    fetchBookings();
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target)
      ) {
        setShowNameSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [dbBlockedDates, setDbBlockedDates] = useState([]);
  const [airbnbBlockedDates, setAirbnbBlockedDates] = useState([]);

  useEffect(() => {
    if (!formData.property) return;
    axios
      .get(`${API_URL}/blocked-dates/${encodeURIComponent(formData.property)}`)
      .then((res) => {
        if (res.data.success) {
          setDbBlockedDates(res.data.dbblockeddates);
          setAirbnbBlockedDates(res.data.airbnbblockeddates);
        }
      })
      .catch((err) => console.error("Failed to fetch blocked dates:", err));
  }, [formData.property]);

  const isDateBlocked = (date) => {
    const str = format(date, "yyyy-MM-dd");
    return dbBlockedDates.includes(str) || airbnbBlockedDates.includes(str);
  };

  const getDayClass = (date) => {
    const str = format(date, "yyyy-MM-dd");
    if (airbnbBlockedDates.includes(str)) return "airbnb-blocked-day";
    if (dbBlockedDates.includes(str)) return "zorba-blocked-day";
    return undefined;
  };
  const hasBlockedDateInRange = (checkoutDate) => {
    if (!formData.checkin) return false;

    const start = new Date(formData.checkin);
    start.setDate(start.getDate() + 1); // day after checkin
    const end = new Date(checkoutDate);

    let current = new Date(start);
    while (current < end) {
      const str = format(current, "yyyy-MM-dd");
      if (dbBlockedDates.includes(str) || airbnbBlockedDates.includes(str)) {
        return true;
      }
      current.setDate(current.getDate() + 1);
    }
    return false;
  };

  const handleSaveBooking = async () => {
    if (!isAdmin) {
      toast.error("Only admins can modify bookings.");
      return;
    }
    const rooms = Number(formData.rooms) || 0;
    const guests = Number(formData.guests) || 0;

    if (rooms === 0 && guests === 0) {
      toast.error("Rooms and Guests cannot be 0");
      return;
    }

    if (rooms === 0) {
      toast.error("Number of rooms cannot be 0");
      return;
    }

    if (guests === 0) {
      toast.error("Number of guests cannot be 0");
      return;
    }
    let data = new FormData();

    // Append formData fields (skip calculated ones — we'll add them fresh below)
    const calculatedKeys = [
      "cgst",
      "sgst",
      "totgst",
      "baseprice",
      "finalprice",
      "profit",
      "isinclusive",
      "secdep",
      "proprice",
    ];

    Object.keys(formData).forEach((key) => {
      if (
        key !== "bookingid" &&
        !calculatedKeys.includes(key) &&
        key !== "checkinHour" &&
        key !== "checkinMinute" &&
        key !== "checkinAmPm" &&
        key !== "checkoutHour" &&
        key !== "checkoutMinute" &&
        key !== "checkoutAmPm" &&
        key !== "checkintime" &&
        key !== "checkouttime" &&
        formData[key] !== undefined &&
        formData[key] !== null
      ) {
        // Don't filter out empty strings for status fields
        if (key === "bookingstatus" || key === "paymentstatus") {
          data.append(key, formData[key] || "Pending");
        } else if (key === "inclusions") {
          // Always append inclusions even if empty — so backend can clear it
          data.append(key, formData[key] ?? "");
        } else if (formData[key] !== "") {
          // 🔥 CRITICAL FIX: Ensure dates are sent as YYYY-MM-DD strings only
          if ((key === "checkin" || key === "checkout") && formData[key]) {
            let dateStr = formData[key];

            // If it's a Date object, convert to YYYY-MM-DD
            if (dateStr instanceof Date) {
              const year = dateStr.getFullYear();
              const month = String(dateStr.getMonth() + 1).padStart(2, "0");
              const day = String(dateStr.getDate()).padStart(2, "0");
              dateStr = `${year}-${month}-${day}`;
            }
            // If it contains 'T', take only the date part
            else if (typeof dateStr === "string" && dateStr.includes("T")) {
              dateStr = dateStr.split("T")[0];
            }
            // If it's already YYYY-MM-DD, keep as is

            data.append(key, dateStr);
          } else {
            data.append(key, formData[key]);
          }
        }
      }
    });

    if (idproofFile) {
      data.append("idproof", idproofFile);
    }
    const checkintime = `${formData.checkinHour}:${formData.checkinMinute} ${formData.checkinAmPm}`;
    const checkouttime = `${formData.checkoutHour}:${formData.checkoutMinute} ${formData.checkoutAmPm}`;
    data.append("checkintime", checkintime);
    data.append("checkouttime", checkouttime);
    // ================================
    // 🔥 GST CALCULATION LOGIC
    // ================================
    const b2c = Number(formData.btocprice || 0);
    const b2b = Number(formData.btobprice || 0);
    const secdepVal = Number(formData.secdep || 0);
    const propriceVal = Number(formData.proprice || 0);

    let baseprice = 0;
    let cgst = 0;
    let sgst = 0;
    let total = 0;

    if (isinclusive) {
      baseprice = b2c / 1.18;
      cgst = baseprice * 0.09;
      sgst = baseprice * 0.09;
      total = b2c; //secdepVal
    } else {
      baseprice = b2c;
      cgst = baseprice * 0.09;
      sgst = baseprice * 0.09;
      total = baseprice + cgst + sgst; //secdepVal
    }

    const profit = b2c - b2b;

    // Always append calculated fields fresh (single source of truth)
    data.append("baseprice", baseprice.toFixed(2));
    data.append("cgst", cgst.toFixed(2));
    data.append("sgst", sgst.toFixed(2));
    data.append("totgst", (cgst + sgst).toFixed(2));
    data.append("finalprice", total.toFixed(2));
    data.append("profit", profit.toFixed(2));
    data.append("isinclusive", isinclusive.toString());
    data.append("secdep", secdepVal.toFixed(2));
    data.append("proprice", propriceVal.toFixed(2));

    try {
      let url = `${API_URL}/createBooking`;
      let method = "POST";

      if (editingBooking) {
        url = `${API_URL}/bookings/${editingBooking.id}`;
        method = "PUT";
      }

      // Debug: Log what's actually being sent
      const formDataEntries = [...data.entries()];
      // console.log("📤 Sending FormData:");
      formDataEntries.forEach(([key, value]) => {
        // console.log(`  ${key}:`, value);
      });

      const res = await fetch(url, { method, body: data });
      const result = await res.json();

      if (result.success) {
        toast.success(
          editingBooking
            ? "Booking updated successfully!"
            : `Booking added successfully! ID: ${result.bookingid}`,
        );

        fetchBookings();
        handleClosePopup();
        setEditingBooking(null);
      } else {
        toast.error("Please enter required fields");
      }
    } catch (err) {
      console.error("Booking error:", err);
      toast.error("Could not connect to server");
    }
  };
  const resetForm = () => {
    setFormData({
      country: "",
      state: "",
      city: "",
      bookingstatus: "Pending", // Add default
      paymentstatus: "Pending", // Add default
    });
    setidproofFile(null);
    setisinclusive(true);
    setEditingBooking(null);
  };

  const handleClosePopup = () => {
    setIsOpen_popupForm(false);
    resetForm();
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const statusColors = {
    CANCELLED: "bg-amber-800/20 text-amber-800",
    CONFIRMED: "bg-green-500/20 text-green-500",
    BOOKED: "bg-purple-500/20 text-purple-500",
    FAILED: "bg-red-500/20 text-red-500",
    PENDING: "bg-yellow-200/40 text-yellow-300",
    PAID: "bg-transparent text-green-500",
    UNPAID: "bg-transparent text-red-400",
    PROCESSING: "bg-pink-200/40 text-pink-300",
  };

  const rowsPerPage_booking = 20;
  const [currentPage_booking, setCurrentPage_booking] = useState(1);
  //   const [selectedRows_booking, setSelectedRows_booking] = useState([]);

  const indexOfLastTable_booking = currentPage_booking * rowsPerPage_booking;
  const indexOfFirstTable_booking =
    indexOfLastTable_booking - rowsPerPage_booking;

  const handlePageChange_booking = (pageNumber_booking) => {
    setCurrentPage_booking(pageNumber_booking);
    // setSelectedRows_booking([]);
  };

  const handleNextPage_booking = () => {
    if (currentPage_booking < totalPages_booking) {
      setCurrentPage_booking(currentPage_booking + 1);
    }
  };

  const handlePrevPage_booking = () => {
    if (currentPage_booking > 1) {
      setCurrentPage_booking(currentPage_booking - 1);
    }
  };

  const generatePageNumbers_booking = () => {
    const pageNumbers_booking = [];

    if (totalPages_booking <= 3) {
      for (let i = 1; i <= totalPages_booking; i++) {
        pageNumbers_booking.push(i);
      }
    } else {
      if (currentPage_booking > 2) {
        pageNumbers_booking.push(1);
        pageNumbers_booking.push("...");
      }
      for (let i = currentPage_booking - 1; i <= currentPage_booking + 1; i++) {
        if (i > 0 && i <= totalPages_booking) {
          pageNumbers_booking.push(i);
        }
      }
      if (currentPage_booking < totalPages_booking - 1) {
        pageNumbers_booking.push("...");
        pageNumbers_booking.push(totalPages_booking);
      }
    }
    return pageNumbers_booking;
  };

  const [selectedRows_booking, setSelectedRows_booking] = useState([]);

  const handleRowCheckboxChange_booking = (order) => {
    setSelectedRows_booking((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_booking = () => {
    if (selectedRows_booking.length === current_booking.length) {
      setSelectedRows_booking([]);
    } else {
      setSelectedRows_booking(
        current_booking.map((booking) => booking.id || booking.bookingid),
      );
    }
  };

  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // when popup opens, set default bookingtime
  useEffect(() => {
    if (isOpen_popupForm) {
      setFormData((prev) => ({
        ...prev,
        bookingtime: new Date().toISOString(), // ISO format (safe for DB)
      }));
    }
  }, [isOpen_popupForm]);
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await fetch(`${API_URL}/properties`);
        const data = await res.json();
        setProperties(data);
      } catch (err) {
        console.error("Error fetching properties:", err);
      }
    };

    fetchProperties();
  }, []);

  const handleDeleteBooking = async (id) => {
    if (!isAdmin) {
      toast.error("🚫 Only admins can modify bookings.");
      return;
    }

    setIsDeleting(true);

    try {
      const res = await fetch(`${API_URL}/bookings/${id}`, {
        method: "DELETE",
      });
      const result = await res.json();

      if (result.success) {
        setDeletePopup({ open: false, bookingid: null });
        setBookings((prev) => prev.filter((b) => b.id !== id));
        toast.success("Booking deleted successfully");
      } else {
        toast.error("Failed to delete: " + (result.error || "Unknown error"));
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Could not connect to server");
    } finally {
      setIsDeleting(false);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // sort alphabetically
  const sortedProperties = [...properties].sort((a, b) =>
    a.propertyname.localeCompare(b.propertyname),
  );

  // filter by search
  const filteredProperties = sortedProperties.filter((p) =>
    p.propertyname.toLowerCase().includes(search.toLowerCase()),
  );
  const normalizeDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const filteredBookings = bookings.filter((b) => {
    const query = searchQuery.toLowerCase();

    const matchesSearch =
      (b.bookingid && b.bookingid.toString().toLowerCase().includes(query)) ||
      `${b.firstname} ${b.lastname}`.toLowerCase().includes(query) ||
      (b.destination && b.destination.toLowerCase().includes(query)) ||
      (b.property && b.property.toLowerCase().includes(query)) ||
      (b.propertycode &&
        b.propertycode.toString().toLowerCase().includes(query));
    let matchesDate = true;
    const checkinDate = normalizeDate(b.checkin);
    const fromDate = normalizeDate(dateFilter.from);
    const toDate = normalizeDate(dateFilter.to);

    if (fromDate) matchesDate = matchesDate && checkinDate >= fromDate;
    if (toDate) matchesDate = matchesDate && checkinDate <= toDate;

    // Tab filter: upcoming vs past based on checkout date
    const checkoutDate = normalizeDate(b.checkout);
    const todayNormalized = normalizeDate(
      new Date().toISOString().split("T")[0],
    );
    const matchesTab =
      bookingTab === "upcoming"
        ? checkoutDate >= todayNormalized
        : checkoutDate < todayNormalized;

    return matchesSearch && matchesDate && matchesTab;
  });
  // 2. Paginate filtered results
  const totalPages_booking = Math.ceil(
    filteredBookings.length / rowsPerPage_booking,
  );
  const current_booking = filteredBookings.slice(
    indexOfFirstTable_booking,
    indexOfLastTable_booking,
  );

  useEffect(() => {
    setCurrentPage_booking(1);
  }, [searchQuery, dateFilter, bookingTab]);
  const today = new Date();
  const setQuickFilter = (type) => {
    let from, to;

    if (type === "Today") {
      from = to = today.toISOString().split("T")[0];
    }

    if (type === "Week") {
      const start = new Date(today);
      start.setDate(today.getDate() - today.getDay()); // start of week (Sunday)
      const end = new Date(start);
      end.setDate(start.getDate() + 6); // end of week (Saturday)

      from = start.toISOString().split("T")[0];
      to = end.toISOString().split("T")[0];
    }

    if (type === "Month") {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      from = start.toISOString().split("T")[0];
      to = end.toISOString().split("T")[0];
    }

    if (type === "Year") {
      const start = new Date(today.getFullYear(), 0, 1);
      const end = new Date(today.getFullYear(), 11, 31);

      from = start.toISOString().split("T")[0];
      to = end.toISOString().split("T")[0];
    }

    setDateFilter({ from, to });
  };
  const [analytics, setAnalytics] = useState({
    totalrevenue: 0,
    pendingpayments: 0,
    profit: 0,
  });

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await axios.get(`${API_URL}/getBookingAnalytics`);
        if (res.data.success) {
          setAnalytics(res.data.analytics);
        }
      } catch (err) {
        console.error(" Error fetching analytics:", err);
      }
    };

    fetchAnalytics();
  }, []);

  // format numbers with commas
  const formatNumber = (num) =>
    new Intl.NumberFormat("en-IN").format(Number(num));
  const [bookedByDate, setBookedByDate] = useState({});

  useEffect(() => {
    const fetchBookedDates = async () => {
      try {
        const res = await fetch(`${API_URL}/getBookingsByDateProp`);
        const data = await res.json();
        if (data.success) setBookedByDate(data.bookings);
      } catch (err) {
        console.error("Error fetching booked dates:", err);
      }
    };
    fetchBookedDates();
  }, []);

  // helper to expand date range
  const getDatesInRange = (start, end) => {
    const dates = [];
    let current = new Date(start);
    const last = new Date(end);
    while (current < last) {
      dates.push(current.toISOString().split("T")[0]); // yyyy-mm-dd
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  const [openMailMenu, setOpenMailMenu] = useState(null);
  // const dropdownRef_mail = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is on any mail button or inside any dropdown
      const isMailButton = event.target.closest(".mail-button");
      const isDropdown = event.target.closest(".mail-dropdown");

      if (!isMailButton && !isDropdown) {
        setOpenMailMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchNameSuggestions = async (firstname) => {
    if (!firstname || firstname.length < 2) {
      setNameSuggestions([]);
      setShowNameSuggestions(false);
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/searchBookingsByName?firstname=${encodeURIComponent(firstname)}`,
      );
      const data = await res.json();

      if (data.success && data.bookings.length > 0) {
        // Group by firstname + lastname to show unique combinations
        const uniqueNames = [];
        const seen = new Set();

        data.bookings.forEach((booking) => {
          const key = `${booking.firstname}|${booking.lastname}`;
          if (!seen.has(key) && booking.firstname) {
            seen.add(key);
            uniqueNames.push(booking);
          }
        });

        setNameSuggestions(uniqueNames);
        setShowNameSuggestions(uniqueNames.length > 0);
      } else {
        setNameSuggestions([]);
        setShowNameSuggestions(false);
      }
    } catch (err) {
      console.error("Error fetching name suggestions:", err);
      setNameSuggestions([]);
      setShowNameSuggestions(false);
    }
  };
  const handleSelectNameSuggestion = (booking) => {
    setFormData((prev) => ({
      ...prev,
      firstname: booking.firstname || "",
      lastname: booking.lastname || "",
      email: booking.email || "",
      phone: booking.phone || "",
      country: booking.country || "",
      state: booking.state || "",
      city: booking.city || "",
      // Optionally fill other fields if you want
      // gstnum: booking.gstnum || "",
      // destination: booking.destination || "",
    }));

    setShowNameSuggestions(false);
    setNameSuggestions([]);
  };

  const handleSendInvoice = async (b) => {
    const customerName = `${b.firstname} ${b.lastname}`;

    // ✅ CONFIRM POPUP
    const confirmSend = window.confirm(
      `Do you want to send "Mail Invoice" to ${customerName}?`,
    );
    if (!confirmSend) return;

    try {
      const loadingToast = toast.loading("Sending Invoice...");

      const response = await fetch(`${API_URL}/sendInvoiceEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          bookingid: b.bookingid,
          customerName,
          email: b.email,
        }),
      });

      const data = await response.json();

      setOpenMailMenu(null);

      if (data.success) {
        toast.update(loadingToast, {
          render: "Invoice sent successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(loadingToast, {
          render: "❌ Failed: " + data.message,
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("⚠️ Error sending invoice");
      setOpenMailMenu(null);
    }
  };

  const handlePDF = (type) => {
    const selectedBookings = current_booking.filter((b) =>
      selectedRows_booking.includes(b.id || b.bookingid),
    );

    if (selectedBookings.length === 0) return;

    const routeMap = {
      "pre-booking": "/prebookingpdf",
      invoice: "/invoice",
      confirmation: "/bookingconfirmpdf",
    };

    const basePath = routeMap[type];
    if (!basePath) return;

    if (selectedBookings.length > 1) {
      toast.info(
        "If your browser blocks some tabs, click the popup icon in your address bar and choose 'Always allow'.",
      );
    }

    selectedBookings.forEach((b, i) => {
      const bookingid = b.bookingid || b.id;
      const url = `${basePath}/${bookingid}?autoprint=1`;
      setTimeout(() => {
        const win = window.open(url, "_blank");
        if (!win) {
          toast.warning(
            `Pop-up blocked for booking ${bookingid}. Please allow pop-ups.`,
          );
        }
      }, i * 150); // stagger slightly
    });
  };

  const getcheckoutDayClass = (date) => {
    const str = format(date, "yyyy-MM-dd");
    const isOccupied =
      airbnbBlockedDates.includes(str) || dbBlockedDates.includes(str);

    if (!isOccupied) return undefined;

    // If selecting this as checkout would still cross a genuinely blocked
    // night, it's hard-blocked — don't show the "checkout only" gray style,
    // let the disabled state (from filterDate) show instead.
    if (hasBlockedDateInRange(date)) return undefined;

    // Otherwise this date is only occupied as someone's checkin — safe to
    // pick as checkout, just flag it visually.
    return "checkout-only-day";
  };
  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Bookings
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              {/* Search bar */}
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                {/* Search icon */}
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>

                {/* Input */}
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />

                {/* Clear button */}
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="text-gray-500 hover:text-black text-lg font-bold px-1"
                  >
                    ×
                  </button>
                )}
              </div>

              <div className="">
                <button className="Btn">
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4 w-64">
                      <h3 className="text-sm font-semibold text-gray-700 mb-2">
                        Filter out on Check-In Date
                      </h3>
                      {/* Quick buttons */}
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            onClick={() => setQuickFilter(label)}
                            className="flex-1 py-1 px-2 bg-gray-100 hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      {/* Custom date range */}
                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <DatePicker
                            selected={
                              dateFilter.from ? parseISO(dateFilter.from) : null
                            }
                            onChange={(date) =>
                              setDateFilter((prev) => ({
                                ...prev,
                                from: date ? format(date, "yyyy-MM-dd") : "",
                              }))
                            }
                            dateFormat="dd-MM-yyyy" // 👈 shows as dd-MM-yyyy
                            placeholderText="dd-mm-yyyy"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <DatePicker
                            selected={
                              dateFilter.to ? parseISO(dateFilter.to) : null
                            }
                            onChange={(date) =>
                              setDateFilter((prev) => ({
                                ...prev,
                                to: date ? format(date, "yyyy-MM-dd") : "",
                              }))
                            }
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-mm-yyyy"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>

                      {/* Apply & Reset */}
                      <div className="flex justify-end gap-2 pt-2">
                        <button
                          onClick={() => setDateFilter({ from: "", to: "" })}
                          className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded"
                        >
                          Reset
                        </button>
                        <button
                          onClick={() => setShowPopup_filter(false)}
                          className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}

                  {deletePopup.open && (
                    <>
                      {/* Overlay — disabled while deleting */}
                      <div
                        className="fixed inset-0 bg-black bg-opacity-40 z-40"
                        onClick={() => {
                          if (!isDeleting)
                            setDeletePopup({ open: false, bookingid: null });
                        }}
                      />

                      {/* Popup box */}
                      <div className="fixed top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-lg w-[90%] max-w-md p-6 text-center">
                        <h2 className="text-lg font-semibold text-gray-800 mb-3">
                          Delete Booking?
                        </h2>
                        <p className="text-sm text-gray-500 mb-6">
                          Are you sure you want to delete this booking? This
                          action cannot be undone.
                        </p>

                        <div className="flex justify-center gap-4">
                          <button
                            onClick={() =>
                              setDeletePopup({ open: false, bookingid: null })
                            }
                            disabled={isDeleting}
                            className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Cancel
                          </button>

                          <button
                            onClick={() =>
                              handleDeleteBooking(deletePopup.bookingid)
                            }
                            disabled={isDeleting}
                            className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2"
                          >
                            {isDeleting ? (
                              <>
                                <svg
                                  className="animate-spin h-4 w-4 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  />
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  />
                                </svg>
                                Deleting...
                              </>
                            ) : (
                              "Delete"
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Boxes */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Total Revenue</p>
              <p className="mt-2 text-lg text-black">
                ₹{formatNumber(analytics.totalrevenue)}
                <sup className="text-green-500">+55%</sup>
              </p>
            </div>

            <div>
              <GiNetworkBars className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Pending Payments</p>
              <p className="mt-2 text-lg text-black">
                ₹{formatNumber(analytics.pendingpayments)}
                <sup className="text-green-500">+5%</sup>
              </p>
            </div>

            <div>
              <BsFillLuggageFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Revenue by Property</p>
              <p className="mt-2 text-lg text-black">
                ₹{formatNumber(analytics.profit)}
                <sup className="text-green-500">+8%</sup>
              </p>
            </div>

            <div>
              <FaMoneyBillTrendUp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        </div>

        {/* Button */}
        {/* Tabs + Button Row */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5 mt-8 ">
          {/* Upcoming / Past Tabs */}
          <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm">
            <button
              onClick={() => setBookingTab("upcoming")}
              className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${
                bookingTab === "upcoming"
                  ? "bg-[#1D2826] text-white"
                  : "bg-white text-gray-500 hover:bg-green-50"
              }`}
            >
              Upcoming Bookings
            </button>
            <button
              onClick={() => setBookingTab("past")}
              className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${
                bookingTab === "past"
                  ? "bg-[#1D2826] text-white"
                  : "bg-white text-gray-500 hover:bg-green-50"
              }`}
            >
              Past Bookings
            </button>
          </div>
          {/* Show PDF buttons only when at least one checkbox is selected */}
          {selectedRows_booking.length > 0 && (
            <>
              <button
                onClick={() => handlePDF("pre-booking")}
                className="px-4 py-2 text-sm border border-blue-400 text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-all duration-200 flex items-center gap-1.5"
              >
                <FiDownload />
                <span>Pre-Booking PDF ({selectedRows_booking.length})</span>
              </button>

              <button
                onClick={() => handlePDF("invoice")}
                className="px-4 py-2 text-sm border border-green-400 text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition-all duration-200 flex items-center gap-1.5"
              >
                <FiDownload />
                <span>Invoice PDF ({selectedRows_booking.length})</span>
              </button>

              <button
                onClick={() => handlePDF("confirmation")}
                className="px-4 py-2 text-sm border border-purple-400 text-purple-700 bg-purple-50 hover:bg-purple-100 rounded-lg transition-all duration-200 flex items-center gap-1.5"
              >
                <FiDownload />
                <span>Confirmation PDF ({selectedRows_booking.length})</span>
              </button>
            </>
          )}
          <div className="flex ">
            {isAdmin && (
              <button
                onClick={() => {
                  setFormMode("add");
                  //---------------//
                  setIsViewOnly(false);
                  setEditingBooking(null);
                  resetForm();
                  setisinclusive(true);
                  //---------------//
                  setIsOpen_popupForm(true);
                }}
                className="px-6 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                // className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 transition-all ease-linear duration-200"
              >
                + Add Booking
              </button>
            )}

            <div className="relative z-50 ">
              {isOpen_popupForm && (
                <div
                  onClick={handleClosePopup}
                  className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
                />
              )}
              {/* Booking POP-UP Main */}
              <div
                className={`  fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
                  isOpen_popupForm ? "translate-x-0" : "translate-x-full"
                } panel_popupForm`}
              >
                <div className="p-4 flex justify-between items-center border-b header_popupForm">
                  <h2 className="text-[#1D2826] text-lg font-semibold">
                    {formMode === "add" && "Add New Booking"}
                    {formMode === "edit" && "Edit Booking"}
                    {formMode === "view" && "View Booking"}
                  </h2>

                  <div className="flex gap-3">
                    {formMode === "view" && (
                      <button
                        onClick={() => {
                          setFormMode("edit");
                          setIsViewOnly(false);
                          setisinclusive(
                            editingBooking?.isinclusive === 1 ||
                              editingBooking?.isinclusive === "1" ||
                              editingBooking?.isinclusive === true ||
                              editingBooking?.isinclusive === "true",
                          );
                        }}
                        className="flex items-center gap-1 text-xs px-4 py-2 bg-green-900 text-white rounded-lg hover:opacity-90"
                      >
                        <FaEdit />
                        Edit Booking
                      </button>
                    )}

                    <button
                      onClick={handleClosePopup}
                      className="text-gray-500 hover:text-black text-xl"
                    >
                      <MdCancel />
                    </button>
                  </div>
                </div>

                <div className="p-4 ">
                  <div className="font-semibold text-gray-500 text-sm text-right">
                    <input
                      type="checkbox"
                      id="isPackageBooking"
                      name="isPackageBooking"
                      checked={formData.isPackageBooking || false}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          isPackageBooking: e.target.checked,
                        }))
                      }
                      className="h-4 w-4 text-green-600 border-gray-400 rounded focus:ring-0 focus:border-black"
                    />
                    <label
                      htmlFor="isPackageBooking"
                      className="text-sm font-medium text-gray-700"
                    >
                      &nbsp; &nbsp;Does this booking belong to a package?
                    </label>
                    {/* Booking ID: <span className="text-black my-1">10294837</span> */}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
                    {/* First Name */}
                    <div
                      className="flex flex-col w-full relative"
                      ref={suggestionRef}
                    >
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        First Name{" "}
                        <sub className="text-red-500 text-base">*</sub>
                      </label>
                      <input
                        placeholder="Enter first name"
                        required
                        name="firstname"
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        value={formData.firstname || ""}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                        autoComplete="off"
                      />
                      {/* Suggestions Dropdown */}
                      {showNameSuggestions && nameSuggestions.length > 0 && (
                        <div className="absolute z-50 top-full left-0 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                          {nameSuggestions.map((suggestion, index) => (
                            <div
                              key={index}
                              onClick={() =>
                                handleSelectNameSuggestion(suggestion)
                              }
                              className="px-4 py-3 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                            >
                              <div className="font-medium">
                                {suggestion.firstname} {suggestion.lastname}
                              </div>
                              <div className="text-xs text-gray-500 mt-1">
                                {suggestion.email && (
                                  <span className="mr-3">
                                    {suggestion.email}
                                  </span>
                                )}
                                {suggestion.phone && (
                                  <span>{suggestion.phone}</span>
                                )}
                              </div>
                              <div className="text-xs text-gray-400 mt-1">
                                {suggestion.county && suggestion.city
                                  ? `${suggestion.city}, ${suggestion.country}`
                                  : suggestion.country || suggestion.city || ""}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {/* Last Name */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Last Name{" "}
                        <sub className="text-red-500 text-base">*</sub>
                      </label>
                      <input
                        placeholder="Enter last name"
                        required
                        name="lastname"
                        value={formData.lastname || ""}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        onChange={handleChange}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Email */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Email <sub className="text-red-500 text-base">*</sub>
                      </label>
                      <input
                        placeholder="Enter your email"
                        required
                        name="email"
                        value={formData.email || ""}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        onChange={handleChange}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Phone Number */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Phone Number
                      </label>
                      <input
                        placeholder="Enter phone number"
                        required
                        name="phone"
                        value={formData.phone || ""}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        onChange={handleChange}
                        maxLength={10}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Country */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "view" ? "z-10" : "z-0"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
                      >
                        Country
                      </label>
                      <select
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                      >
                        <option value="">Select your country</option>
                        {worldData.map((country) => (
                          <option key={country.id} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* State */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "edit" ? "z-0" : "z-10"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative z-10 top-2 ml-2 px-1 bg-white w-fit"
                      >
                        State
                      </label>
                      <select
                        name="state"
                        value={formData.state || ""}
                        onChange={handleChange}
                        disabled={isViewOnly || !formData.country}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                      >
                        <option value="">Select your state</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* City */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "edit" ? "z-0" : "z-10"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative z-10 top-2 ml-2 px-1 bg-white w-fit"
                      >
                        City
                      </label>
                      <select
                        name="city"
                        value={formData.city || ""}
                        onChange={handleChange}
                        disabled={isViewOnly || !formData.state}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                      >
                        <option value="">Select your city</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.name}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Booking Date & Time */}
                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Booking Date & Time
                      </label>
                      <input
                        type="text"
                        name="bookingtime"
                        readOnly
                        value={
                          formData.bookingtime
                            ? new Date(formData.bookingtime).toLocaleString()
                            : ""
                        }
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md text-black"
                      />
                    </div>

                    {/* Check In Date + Time */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="checkin"
                        className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Check In Date
                      </label>
                      <DatePicker
                        selected={
                          formData.checkin
                            ? (() => {
                                if (formData.checkin instanceof Date)
                                  return formData.checkin;
                                if (
                                  typeof formData.checkin === "string" &&
                                  formData.checkin.includes("T")
                                )
                                  return new Date(formData.checkin);
                                if (
                                  typeof formData.checkin === "string" &&
                                  /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
                                ) {
                                  const [year, month, day] = formData.checkin
                                    .split("-")
                                    .map(Number);
                                  return new Date(year, month - 1, day);
                                }
                                return new Date(formData.checkin);
                              })()
                            : null
                        }
                        onChange={(date) => {
                          const newcheckin = date
                            ? format(date, "yyyy-MM-dd")
                            : "";
                          setFormData((prev) => ({
                            ...prev,
                            checkin: newcheckin,
                            checkout: "",
                            btocprice: "",
                          }));
                        }}
                        dateFormat="dd-MM-yyyy"
                        minDate={new Date()}
                        filterDate={(date) => !isDateBlocked(date)}
                        dayClassName={getDayClass}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
                        disabled={isViewOnly || !formData.property}
                        placeholderText={
                          !formData.property
                            ? "Select a property first"
                            : "dd-mm-yyyy"
                        }
                      />
                      {/* Check In Time */}
                      <div className="flex gap-2 mt-2">
                        <select
                          name="checkinHour"
                          value={formData.checkinHour || "12"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          {Array.from({ length: 12 }, (_, i) => {
                            const h = String(i + 1).padStart(2, "0");
                            return (
                              <option key={h} value={h}>
                                {h}
                              </option>
                            );
                          })}
                        </select>
                        <select
                          name="checkinMinute"
                          value={formData.checkinMinute || "00"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          {["00", "15", "30", "45"].map((m) => (
                            <option key={m} value={m}>
                              {m}
                            </option>
                          ))}
                        </select>
                        <select
                          name="checkinAmPm"
                          value={formData.checkinAmPm || "PM"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>

                    {/* Check Out Date + Time */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="checkout"
                        className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Check Out Date
                      </label>
                      <DatePicker
                        selected={
                          formData.checkout
                            ? (() => {
                                if (formData.checkout instanceof Date)
                                  return formData.checkout;
                                if (
                                  typeof formData.checkout === "string" &&
                                  formData.checkout.includes("T")
                                )
                                  return new Date(formData.checkout);
                                if (
                                  typeof formData.checkout === "string" &&
                                  /^\d{4}-\d{2}-\d{2}$/.test(formData.checkout)
                                ) {
                                  const [year, month, day] = formData.checkout
                                    .split("-")
                                    .map(Number);
                                  return new Date(year, month - 1, day);
                                }
                                return new Date(formData.checkout);
                              })()
                            : null
                        }
                        onChange={(date) => {
                          const newcheckout = date
                            ? format(date, "yyyy-MM-dd")
                            : "";
                          setFormData((prev) => {
                            const proprice = parseFloat(prev.proprice) || 0;
                            const checkin = prev.checkin;
                            let btocprice = prev.btocprice;
                            if (checkin && newcheckout && proprice > 0) {
                              let checkinDate;
                              if (
                                typeof checkin === "string" &&
                                /^\d{4}-\d{2}-\d{2}$/.test(checkin)
                              ) {
                                const [y, m, d] = checkin
                                  .split("-")
                                  .map(Number);
                                checkinDate = new Date(y, m - 1, d);
                              } else {
                                checkinDate = new Date(checkin);
                              }
                              let checkoutDate;
                              if (
                                typeof newcheckout === "string" &&
                                /^\d{4}-\d{2}-\d{2}$/.test(newcheckout)
                              ) {
                                const [y, m, d] = newcheckout
                                  .split("-")
                                  .map(Number);
                                checkoutDate = new Date(y, m - 1, d);
                              } else {
                                checkoutDate = new Date(newcheckout);
                              }
                              const nights = Math.max(
                                0,
                                Math.round(
                                  (checkoutDate - checkinDate) /
                                    (1000 * 60 * 60 * 24),
                                ),
                              );
                              btocprice = (nights * proprice).toFixed(2);
                            }
                            return {
                              ...prev,
                              checkout: newcheckout,
                              btocprice,
                            };
                          });
                        }}
                        dateFormat="dd-MM-yyyy"
                        filterDate={(date) => !hasBlockedDateInRange(date)}
                        dayClassName={getcheckoutDayClass}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
                        placeholderText={
                          !formData.checkin
                            ? "Select check-in first"
                            : "dd-mm-yyyy"
                        }
                        disabled={!formData.checkin || isViewOnly}
                        minDate={
                          formData.checkin
                            ? (() => {
                                let checkinDate;
                                if (
                                  typeof formData.checkin === "string" &&
                                  /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
                                ) {
                                  const [y, m, d] = formData.checkin
                                    .split("-")
                                    .map(Number);
                                  checkinDate = new Date(y, m - 1, d);
                                } else {
                                  checkinDate = new Date(formData.checkin);
                                }
                                checkinDate.setDate(checkinDate.getDate() + 1);
                                return checkinDate;
                              })()
                            : null
                        }
                      />
                      {/* Check Out Time */}
                      <div className="flex gap-2 mt-2">
                        <select
                          name="checkoutHour"
                          value={formData.checkoutHour || "11"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          {Array.from({ length: 12 }, (_, i) => {
                            const h = String(i + 1).padStart(2, "0");
                            return (
                              <option key={h} value={h}>
                                {h}
                              </option>
                            );
                          })}
                        </select>
                        <select
                          name="checkoutMinute"
                          value={formData.checkoutMinute || "00"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          {["00", "15", "30", "45"].map((m) => (
                            <option key={m} value={m}>
                              {m}
                            </option>
                          ))}
                        </select>
                        <select
                          name="checkoutAmPm"
                          value={formData.checkoutAmPm || "AM"}
                          onChange={handleChange}
                          disabled={isViewOnly}
                          className="border-gray-400 p-2 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>
                    {/* Booking status */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "view" ? "z-10" : "z-0"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
                      >
                        Booking Status
                      </label>

                      <select
                        name="bookingstatus"
                        value={formData.bookingstatus} // controlled value
                        onChange={handleChange}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      >
                        {/* <option value="">Select booking status</option> */}
                        <option value="Pending">Pending</option>
                        <option value="Booked">Booked</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Processing">Processing</option>
                      </select>
                    </div>
                    {/* Payment Status */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "view" ? "z-10" : "z-0"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
                      >
                        Payment Status
                      </label>

                      <select
                        name="paymentstatus"
                        value={formData.paymentstatus} // controlled value
                        onChange={handleChange}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      >
                        {/* <option value="">Select payment status</option> */}
                        <option value="Paid">Paid</option>
                        <option value="Pending">Pending</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </div>
                    {/* Trip Executive */}
                    <div className="flex flex-col w-full">
                      <label
                        className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
                          formMode === "view" ? "z-10" : "z-0"
                        }`}
                        // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
                      >
                        Trip Executive
                      </label>

                      <select
                        name="tripexecutive"
                        value={formData.tripexecutive || ""}
                        onChange={handleChange}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      >
                        <option value="">Select Trip Executive</option>
                        {executives.map((exec, idx) => (
                          <option key={idx} value={exec.name}>
                            {exec.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* destination */}
                    <div
                      className={`flex flex-col w-full ${
                        formData.isPackageBooking
                          ? "sm:col-span-1"
                          : "sm:col-span-1"
                      }`}
                    >
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        destination
                      </label>
                      <input
                        placeholder="Enter destination"
                        required
                        name="destination"
                        value={formData.destination || ""}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Property Dropdown */}
                    <div
                      className="flex flex-col w-full relative"
                      ref={dropdownRef}
                    >
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Property
                      </label>

                      {/* Display selected value */}
                      <div
                        onClick={() => {
                          if (!isViewOnly) {
                            setIsOpen(!isOpen);
                          }
                        }}
                        className={`border-gray-400 p-3 text-sm border rounded-lg w-full cursor-pointer focus:outline-none ${
                          isViewOnly
                            ? "bg-gray-100 cursor-not-allowed"
                            : "bg-white"
                        }`}
                      >
                        <span
                          className={
                            formData.property
                              ? "text-gray-800"
                              : "text-gray-400"
                          }
                        >
                          {formData.property || "Select a property"}
                        </span>

                        {formData.property && !isViewOnly && (
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormData((prev) => ({
                                ...prev,
                                property: "",
                                rooms: 0,
                                guests: 0,
                                checkin: "",
                                checkout: "",
                                btocprice: "",
                                checkinHour: "12",
                                checkinMinute: "00",
                                checkinAmPm: "PM",
                                checkoutHour: "11",
                                checkoutMinute: "00",
                                checkoutAmPm: "AM",
                              }));
                              setDbBlockedDates([]);
                              setAirbnbBlockedDates([]);
                            }}
                            className="absolute right-2 top-9 -translate-y-1/2 cursor-pointer text-gray-300 hover:text-red-400 transition text-sm leading-none"
                            title="Clear property"
                          >
                            ✕
                          </span>
                        )}
                      </div>

                      {isOpen && !isViewOnly && (
                        <div className="absolute z-20 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                          {/* Toggle for Add Property */}
                          <div className="flex items-center justify-between px-3 py-2 border-b bg-gray-50">
                            <span className="text-sm font-semibold text-gray-600">
                              Select or Add Property
                            </span>
                            <button
                              type="button"
                              onClick={() => setManualMode((prev) => !prev)}
                              className="text-blue-600 text-xs font-medium hover:underline"
                            >
                              {manualMode ? "← Back to list" : "+ Add manually"}
                            </button>
                          </div>

                          {/* Search / Manual Input */}
                          <div className="flex items-center p-2 border-b">
                            {manualMode ? (
                              <div className="flex items-center gap-2 w-full">
                                <input
                                  type="text"
                                  placeholder="Enter property name"
                                  className="flex-1 p-2 text-sm border rounded focus:outline-none"
                                  value={manualProperty}
                                  onChange={(e) =>
                                    setManualProperty(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Enter" &&
                                      manualProperty.trim()
                                    ) {
                                      setFormData((prev) => ({
                                        ...prev,
                                        property: manualProperty.trim(),
                                        checkin: "",
                                        checkout: "",
                                        btocprice: "",
                                        checkinHour: "12",
                                        checkinMinute: "00",
                                        checkinAmPm: "PM",
                                        checkoutHour: "11",
                                        checkoutMinute: "00",
                                        checkoutAmPm: "AM",
                                      }));
                                      setDbBlockedDates([]);
                                      setAirbnbBlockedDates([]);
                                      setIsOpen(false);
                                      setManualMode(false);
                                      setManualProperty("");
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  disabled={!manualProperty.trim()}
                                  onClick={() => {
                                    if (!manualProperty.trim()) return;
                                    setFormData((prev) => ({
                                      ...prev,
                                      property: manualProperty.trim(),
                                      checkin: "",
                                      checkout: "",
                                      btocprice: "",
                                      checkinHour: "12",
                                      checkinMinute: "00",
                                      checkinAmPm: "PM",
                                      checkoutHour: "11",
                                      checkoutMinute: "00",
                                      checkoutAmPm: "AM",
                                    }));
                                    setDbBlockedDates([]);
                                    setAirbnbBlockedDates([]);
                                    setIsOpen(false);
                                    setManualMode(false);
                                    setManualProperty("");
                                  }}
                                  className="px-3 py-2 text-sm bg-gray-400 text-white rounded hover:bg-gray-500 transition disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                                >
                                  + Add
                                </button>
                              </div>
                            ) : (
                              <input
                                type="text"
                                placeholder="Type a property"
                                className="w-full p-2 text-sm border rounded focus:outline-none"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            )}
                          </div>

                          {/* List */}
                          {!manualMode && (
                            <ul className="max-h-48 overflow-y-auto">
                              {filteredProperties.length > 0 ? (
                                filteredProperties.map((p) => {
                                  let isUnavailable = false;

                                  if (formData.checkin && formData.checkout) {
                                    const selectedDates = getDatesInRange(
                                      formData.checkin,
                                      formData.checkout,
                                    );

                                    isUnavailable = selectedDates.some(
                                      (date) => {
                                        const bookingsForDate =
                                          bookedByDate[date] || [];
                                        return bookingsForDate.some(
                                          (b) =>
                                            b.property === p.propertyname &&
                                            (!editingBooking ||
                                              b.bookingid !==
                                                editingBooking.bookingid),
                                        );
                                      },
                                    );
                                  }

                                  return (
                                    <li
                                      key={p.id}
                                      // onClick={() => {
                                      //   if (isUnavailable) return;
                                      //   handleChange({
                                      //     target: {
                                      //       name: "property",
                                      //       value: p.propertyname,
                                      //     },
                                      //   });
                                      //   setIsOpen(false);
                                      //   setSearch("");
                                      // }}
                                      onClick={() => {
                                        if (isUnavailable) return;

                                        const selectedProperty =
                                          properties.find(
                                            (prop) =>
                                              prop.propertyname ===
                                              p.propertyname,
                                          );

                                        setFormData((prev) => ({
                                          ...prev,
                                          property: p.propertyname,
                                          rooms: selectedProperty?.maxbed ?? 0,
                                          guests:
                                            selectedProperty?.maxadult ?? 0,
                                          checkin: "", // 👈 reset dates
                                          checkout: "", // 👈 reset dates
                                          btocprice: "", // 👈 reset calculated price
                                          checkinHour: "12",
                                          checkinMinute: "00",
                                          checkinAmPm: "PM",
                                          checkoutHour: "11",
                                          checkoutMinute: "00",
                                          checkoutAmPm: "AM",
                                        }));

                                        setIsOpen(false);
                                        setSearch("");
                                      }}
                                      className={`px-4 py-2 text-sm ${
                                        isUnavailable
                                          ? "text-gray-400 cursor-not-allowed line-through"
                                          : "hover:bg-gray-100 cursor-pointer"
                                      }`}
                                      title={
                                        isUnavailable
                                          ? "This property is already booked"
                                          : ""
                                      }
                                    >
                                      {p.propertyname}
                                    </li>
                                  );
                                })
                              ) : (
                                <li className="px-4 py-2 text-gray-400 text-sm">
                                  No results found
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      )}
                    </div>
                    {/* Property Price */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="proprice"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Property Price (Per Night)
                      </label>
                      <input
                        type="text"
                        step="0.01"
                        placeholder="Enter total amount"
                        name="proprice"
                        value={formData.proprice || ""}
                        // onChange={handleChange}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers and one decimal point
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    {/* Number of Room */}
                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Number of Rooms{" "}
                        <sub className="text-red-500 text-base">*</sub>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="Enter No. Rooms"
                        name="rooms"
                        value={formData.rooms ?? ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Only allow numbers
                          if (value === "" || /^[0-9]+$/.test(value)) {
                            setFormData((prev) => ({
                              ...prev,
                              [name]: value === "" ? "" : parseInt(value, 10),
                            }));
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    {/* Number of Guests */}
                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Number of Guests{" "}
                        <sub className="text-red-500 text-base">*</sub>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="Enter No. Guests"
                        name="guests"
                        value={formData.guests ?? ""}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Only allow numbers
                          if (value === "" || /^[0-9]+$/.test(value)) {
                            setFormData((prev) => ({
                              ...prev,
                              [name]: value === "" ? "" : parseInt(value, 10),
                            }));
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Advance Payment */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="advpay"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Advance Payment
                      </label>
                      <input
                        type="text"
                        step="0.01"
                        placeholder="Enter advance payment"
                        name="advpay"
                        value={formData.advpay || ""}
                        // onChange={handleChange}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers and one decimal point
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Balance Amount */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="balpay"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Balance Amount
                      </label>
                      <input
                        type="text"
                        step="0.01"
                        placeholder="Enter balance amount"
                        name="balpay"
                        value={formData.balpay || ""}
                        //  onChange={handleChange}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers and one decimal point
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Price Shown to Bussiness */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        B2B Price
                      </label>
                      <input
                        placeholder="Enter B2B Price"
                        name="btobprice"
                        value={formData.btobprice || ""}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Price Shown to Customer */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        B2C Price
                      </label>
                      <input
                        placeholder="Enter B2C Price"
                        name="btocprice"
                        value={formData.btocprice || ""}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Inclusive of GST */}
                    <div className="font-semibold text-gray-500 text-sm ">
                      <input
                        type="checkbox"
                        checked={isinclusive}
                        // onChange={(e) => setisinclusive(e.target.checked)}
                        onChange={(e) => {
                          const newValue = e.target.checked;

                          // If trying to uncheck (from true to false)
                          if (isinclusive === true && newValue === false) {
                            setPendingGstValue(false);
                            setShowGstConfirm(true);
                          } else {
                            // If checking (from false to true), just update
                            setisinclusive(newValue);
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="h-4 w-4 text-green-600 border-gray-400 rounded focus:ring-0 focus:border-black"
                      />
                      <label
                        htmlFor=""
                        className="text-sm font-medium text-gray-700"
                      >
                        &nbsp; &nbsp;Inclusive GST
                      </label>
                    </div>
                    {/* GST Confirmation Popup */}
                    {showGstConfirm && (
                      <>
                        {/* Overlay */}
                        <div
                          className="fixed inset-0 bg-black bg-opacity-30 z-[60]"
                          onClick={() => setShowGstConfirm(false)}
                        />

                        {/* Popup */}
                        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-lg z-[70] w-[90%] max-w-md p-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-3">
                            Confirm GST Change
                          </h3>

                          <p className="text-sm text-gray-600 mb-6">
                            By unchecking this, 18% GST will be added to the
                            total price. Are you sure you want to continue?
                          </p>

                          <div className="flex justify-end gap-3">
                            <button
                              onClick={() => {
                                setShowGstConfirm(false);
                                setPendingGstValue(null);
                              }}
                              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
                            >
                              Cancel
                            </button>

                            <button
                              onClick={() => {
                                setisinclusive(pendingGstValue);
                                setShowGstConfirm(false);
                                setPendingGstValue(null);
                              }}
                              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    {/*  Profit Display */}
                    <div>
                      {formData.btocprice && formData.btobprice && (
                        <p className="text-green-600 text-sm mt-1">
                          Profit revenue for this booking: ₹
                          {Number(formData.btocprice || 0) -
                            Number(formData.btobprice || 0)}
                        </p>
                      )}
                    </div>

                    {/*  CGST Display Make sure user cant write it should be autofilled */}

                    {!isinclusive ? (
                      <>
                        {/* CGST Display */}
                        <div className="flex flex-col w-full">
                          <label
                            htmlFor="input"
                            className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                          >
                            CGST (9%)
                          </label>
                          <input
                            placeholder="0"
                            value={cgst.toFixed(2)}
                            readOnly={isViewOnly}
                            disabled={isViewOnly}
                            className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                          />
                        </div>
                        {/* SGST Display */}
                        <div className="flex flex-col w-full">
                          <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                            SGST (9%)
                          </label>
                          <input
                            placeholder="0"
                            value={sgst.toFixed(2)}
                            readOnly={isViewOnly}
                            disabled={isViewOnly}
                            className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                          />
                        </div>
                      </>
                    ) : (
                      // When Inclusive is checked, add empty divs to maintain grid
                      <>
                        <div className="hidden sm:block"></div>
                        <div className="hidden sm:block"></div>
                      </>
                    )}
                    {/* Security Deposit */}
                    <div className="flex flex-col w-full">
                      <label
                        htmlFor="secdep"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Security Deposit
                      </label>
                      <input
                        type="text"
                        step="0.01"
                        placeholder="Enter security deposit"
                        name="secdep"
                        value={formData.secdep || ""}
                        // onChange={handleChange}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers and one decimal point
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleChange(e);
                          }
                        }}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Total Price */}
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Total Price
                      </label>
                      <input
                        name=""
                        value={total.toFixed(2)}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* GST Number */}
                    <div className="flex flex-col w-full ">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        GST Number
                      </label>
                      <input
                        placeholder="Enter GST Number"
                        name="gstnum"
                        value={formData.gstnum || ""}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>
                    {/* Package input (only if checkbox is checked) */}
                    {formData.isPackageBooking && (
                      <div className="flex flex-col w-full">
                        <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                          Package
                        </label>
                        <input
                          placeholder="Enter package name"
                          name="package"
                          value={formData.package || ""}
                          onChange={handleChange}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                        />
                      </div>
                    )}
                    {/* Inclusions */}
                    <div className="flex flex-col w-full sm:col-span-2">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Inclusions
                      </label>
                      <textarea
                        placeholder="e.g. Attendant for Breakfast, Groceries as per actuals"
                        name="inclusions"
                        value={formData.inclusions || ""}
                        onChange={handleChange}
                        readOnly={isViewOnly}
                        disabled={isViewOnly}
                        rows={3}
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md resize-none"
                      />
                    </div>
                    <div className="flex flex-col w-full sm:col-span-2">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        ID Proof
                      </label>

                      {isViewOnly ? (
                        editingBooking?.idproof ? (
                          <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
                            <a
                              href={`${API_URL}/bookings/${editingBooking?.id}/idproof`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                            >
                              Download
                            </a>
                          </div>
                        ) : (
                          // ✅ View mode: no file → show message
                          <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
                            <p className="text-sm text-red-500">
                              ID Proof was not uploaded
                            </p>
                          </div>
                        )
                      ) : editingBooking?.idproof ? (
                        // ✅ Edit mode: file exists → download + replace
                        <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
                          <p className="text-sm text-gray-700">
                            Existing file uploaded
                          </p>
                          <div className="flex gap-3">
                            <a
                              href={`${API_URL}/bookings/${editingBooking?.id}/idproof`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                            >
                              Download
                            </a>
                            <button
                              onClick={handleBoxClick}
                              type="button"
                              className="px-3 py-1 bg-gray-700 text-white rounded text-sm"
                            >
                              Replace File
                            </button>
                          </div>
                        </div>
                      ) : (
                        // ✅ Edit mode: no file yet → upload
                        <div
                          onClick={handleBoxClick}
                          className="border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center text-center p-6 cursor-pointer hover:border-black transition-all"
                        >
                          <FiUploadCloud className="w-10 h-10 text-green-600 mb-2" />
                          <p className="text-sm font-medium text-black">
                            {idproofFile
                              ? idproofFile.name
                              : "Select File to Upload"}
                          </p>
                          <p className="text-xs text-gray-400">Image or PDF</p>
                        </div>
                      )}

                      {!isViewOnly && (
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*,.pdf"
                          className="hidden"
                          onChange={handleFileChange}
                        />
                      )}
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={handleClosePopup}
                        className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={handleSaveBooking}
                        className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <a
            href="/BookingCalendar"
            className="px-6 z-30 py-2 bg-gray-500 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
          >
            Booking Calendar
          </a> */}
          </div>
        </div>

        {/* Table */}
        <div>
          <div className="shadow-md rounded-lg mt-5">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll_booking}
                        checked={
                          selectedRows_booking.length ===
                            current_booking.length && current_booking.length > 0
                        }
                      />
                    </th>
                    <th className="p-4 w-1/12">Booking ID</th>
                    <th className="p-4 w-1/10">Customer Name</th>
                    <th className="p-4 w-1/10">Property Code</th>
                    <th className="p-4 w-1/10">Package / destination</th>
                    <th className="p-4 w-1/10">Booking Date</th>
                    <th className="p-4 w-1/10">Check-In Date</th>
                    <th className="p-4 w-1/10">Check-Out Date</th>
                    <th className="p-4 w-1/10">Status</th>
                    <th className="p-4 w-1/10">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showLoader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader
                          label="Loading..."
                          fullScreen={false}
                          className="py-2"
                        />
                      </td>
                    </tr>
                  ) : current_booking.length === 0 ? (
                    <tr>
                      <td
                        colSpan={10}
                        className="text-center py-14 text-gray-400"
                      >
                        No bookings found.
                      </td>
                    </tr>
                  ) : (
                    current_booking.map((b) => (
                      <tr
                        key={b.id || b.bookingid}
                        className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                      >
                        {/* Checkbox */}
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleRowCheckboxChange_booking(
                                b.id || b.bookingid,
                              )
                            }
                            checked={selectedRows_booking.includes(
                              b.id || b.bookingid,
                            )}
                          />
                        </td>
                        {/* Booking ID */}
                        <td className="px-4 py-3 font-semibold text-gray-700">
                          {b.bookingid || "-"}
                        </td>
                        {/* Customer Name */}
                        <td className="px-4 py-3">
                          <Tooltip
                            title={`${b.firstname} ${b.lastname}`}
                            placement="left"
                          >
                            {b.firstname} {b.lastname}
                          </Tooltip>
                        </td>

                        {/* Property Code */}
                        <td className="px-4 py-3">
                          <Tooltip title={`${b.property}`} placement="left">
                            {b.property}
                          </Tooltip>
                        </td>

                        {/* destination */}
                        <td className="px-4 py-3">
                          <Tooltip
                            title={
                              b.package
                                ? `${b.package}-${b.destination}`
                                : b.destination || "-"
                            }
                            placement="left"
                          >
                            {b.package
                              ? `${b.package}-${b.destination}`
                              : b.destination || "-"}
                          </Tooltip>
                        </td>

                        {/* Booking Date */}
                        <td className="px-4 py-3">
                          <Tooltip title={b.bookingtime} placement="left">
                            {b.bookingtime
                              ? new Date(b.bookingtime).toLocaleDateString(
                                  "en-GB",
                                )
                              : "-"}
                          </Tooltip>
                        </td>

                        {/* Check-In */}
                        <td className="px-4 py-3">
                          <Tooltip
                            title={
                              b.checkin
                                ? new Date(b.checkin).toLocaleDateString(
                                    "en-GB",
                                  ) // dd/mm/yyyy
                                : "-"
                            }
                            placement="left"
                          >
                            {b.checkin
                              ? new Date(b.checkin).toLocaleDateString("en-GB")
                              : "-"}
                          </Tooltip>
                        </td>

                        {/* Check-Out */}
                        <td className="px-4 py-3">
                          <Tooltip
                            title={
                              b.checkout
                                ? new Date(b.checkout).toLocaleDateString(
                                    "en-GB",
                                  )
                                : "-"
                            }
                            placement="left"
                          >
                            {b.checkout
                              ? new Date(b.checkout).toLocaleDateString("en-GB")
                              : "-"}
                          </Tooltip>
                        </td>
                        {/* Status */}
                        <td className="px-4 py-3 text-center">
                          <div className="flex justify-between items-center">
                            <button
                              className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                statusColors[b.bookingstatus?.toUpperCase()] ||
                                ""
                              }`}
                            >
                              {b.bookingstatus || "PENDING"}
                            </button>
                          </div>
                        </td>

                        {/* Actions */}
                        <td>
                          <div className="grid grid-cols-2 gap-y-1 my-2">
                            {/* Everyone can view */}
                            <Tooltip title="View Booking" placement="top">
                              <button
                                className="relative group pl-4 py-1 text-gray-400 hover:text-sky-500 hover:scale-125 transition-all"
                                onClick={() => {
                                  setEditingBooking(b);

                                  // 🔥 Format dates using the helper function
                                  const formattedcheckin = formatDateForDisplay(
                                    b.checkin,
                                  );
                                  const formattedcheckout =
                                    formatDateForDisplay(b.checkout);

                                  const parseTime = (
                                    timeStr,
                                    fallbackHour,
                                    fallbackAmPm,
                                  ) => {
                                    if (!timeStr)
                                      return {
                                        hour: fallbackHour,
                                        minute: "00",
                                        ampm: fallbackAmPm,
                                      };
                                    const match = timeStr.match(
                                      /^(\d{2}):(\d{2})\s*(AM|PM)$/i,
                                    );
                                    if (!match)
                                      return {
                                        hour: fallbackHour,
                                        minute: "00",
                                        ampm: fallbackAmPm,
                                      };
                                    return {
                                      hour: match[1],
                                      minute: match[2],
                                      ampm: match[3].toUpperCase(),
                                    };
                                  };

                                  const ci = parseTime(
                                    b.checkintime,
                                    "12",
                                    "PM",
                                  );
                                  const co = parseTime(
                                    b.checkouttime,
                                    "11",
                                    "AM",
                                  );

                                  setFormData({
                                    ...b,
                                    isPackageBooking: !!b.package,
                                    bookingtime: b.bookingtime
                                      ? new Date(b.bookingtime).toISOString()
                                      : new Date().toISOString(),
                                    checkin: formattedcheckin,
                                    checkout: formattedcheckout,
                                    proprice: b.proprice || "",
                                    secdep: b.secdep || "",
                                    inclusions: b.inclusions || "",
                                    checkinHour: ci.hour,
                                    checkinMinute: ci.minute,
                                    checkinAmPm: ci.ampm,
                                    checkoutHour: co.hour,
                                    checkoutMinute: co.minute,
                                    checkoutAmPm: co.ampm,
                                  });

                                  setisinclusive(
                                    b.isinclusive === 1 ||
                                      b.isinclusive === "1" ||
                                      b.isinclusive === true ||
                                      b.isinclusive === "true",
                                  );
                                  setFormMode("view");
                                  setIsViewOnly(true);
                                  setIsOpen_popupForm(true);
                                }}
                              >
                                <FaEye
                                  size={22}
                                  className="border border-sky-300 rounded-full p-0.5"
                                />
                              </button>
                            </Tooltip>

                            {/* Only admins can edit/delete */}
                            {isAdmin && (
                              <>
                                <Tooltip title="Feedback" placement="top">
                                  <button
                                    onClick={() =>
                                      navigate(`/FeedbackForm/${b.id}`, {
                                        state: { from: "bookings" },
                                      })
                                    }
                                    className="pl-2 py-1 text-gray-400 hover:text-yellow-300 hover:scale-125 transition-all"
                                  >
                                    <RiFileEditFill
                                      size={22}
                                      className="border border-yellow-300 rounded-full p-0.5"
                                    />
                                  </button>
                                </Tooltip>

                                <div className="relative inline-block">
                                  <Tooltip title="Send Mail" placement="top">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        // console.log(
                                        //   "🔵 Mail button clicked for booking ID:",
                                        //   b.id,
                                        // );

                                        // Toggle this specific dropdown
                                        setOpenMailMenu(
                                          openMailMenu === b.id ? null : b.id,
                                        );
                                      }}
                                      className="pl-4 py-1 text-gray-400 hover:text-purple-500 hover:scale-125 transition-all mail-button"
                                    >
                                      <IoIosMail
                                        size={23}
                                        className="border border-purple-300 rounded-full p-0.5"
                                      />
                                    </button>
                                  </Tooltip>
                                  {openMailMenu === b.id && (
                                    <div className="absolute right-0 mt-0 w-48 bg-white border rounded-lg rounded-tr-none shadow-custom z-50 mail-dropdown">
                                      {/* Send Pre Booking Email */}
                                      <button
                                        className="block w-full text-sm text-left px-2 py-2 border-b hover:bg-green-50 hover:rounded-t-lg group"
                                        onClick={async (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();

                                          const customerName = `${b.firstname} ${b.lastname}`;

                                          const confirmSend = window.confirm(
                                            `Do you want to send "Proforma Invoice" to ${customerName}?`,
                                          );
                                          if (!confirmSend) return;

                                          try {
                                            const loadingToast = toast.loading(
                                              "Sending Proforma Invoice email...",
                                            );

                                            const response = await fetch(
                                              `${API_URL}/bookings/${b.id}/send-email`,
                                              {
                                                method: "POST",
                                                headers: {
                                                  "Content-Type":
                                                    "application/json",
                                                },
                                                body: JSON.stringify({
                                                  type: "pre-booking",
                                                  bookingid: b.bookingid,
                                                  customerName,
                                                  email: b.email,
                                                }),
                                              },
                                            );

                                            const result =
                                              await response.json();

                                            setOpenMailMenu(null);

                                            if (result.success) {
                                              toast.update(loadingToast, {
                                                render:
                                                  " Proforma Invoice sent successfully!",
                                                type: "success",
                                                isLoading: false,
                                                autoClose: 3000,
                                              });
                                            } else {
                                              toast.update(loadingToast, {
                                                render:
                                                  " Failed: " +
                                                  (result.error ||
                                                    "Unknown error"),
                                                type: "error",
                                                isLoading: false,
                                                autoClose: 3000,
                                              });
                                            }
                                          } catch (error) {
                                            console.error(error);
                                            toast.error(" Error sending mail");
                                            setOpenMailMenu(null);
                                          }
                                        }}
                                      >
                                        <span className="flex items-center gap-0.5">
                                          <LuArrowBigRightDash className="group-hover:fill-black" />
                                          Mail Proforma Invoice
                                        </span>
                                      </button>
                                      {/* Send Mail Invoice */}
                                      <button
                                        className="block w-full text-sm text-left px-2 py-2 hover:bg-green-50 group"
                                        onClick={() => handleSendInvoice(b)}
                                      >
                                        <span className="flex items-center gap-0.5">
                                          <LuArrowBigRightDash className="group-hover:fill-black" />
                                          Mail Invoice
                                        </span>
                                      </button>
                                      {/* Send Confirmation  */}
                                      <button
                                        onClick={async (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();

                                          const customerName = `${b.firstname} ${b.lastname}`;

                                          const confirmSend = window.confirm(
                                            `Do you want to send "Confirm  Booking" to ${customerName}?`,
                                          );
                                          if (!confirmSend) return;

                                          try {
                                            const loadingToast = toast.loading(
                                              "Sending Confirm Booking email...",
                                            );

                                            const response = await fetch(
                                              `${API_URL}/confirmBookings/${b.id}/send-email`,
                                              {
                                                method: "POST",
                                                headers: {
                                                  "Content-Type":
                                                    "application/json",
                                                },
                                                body: JSON.stringify({
                                                  type: "pre-booking",
                                                  bookingid: b.bookingid,
                                                  customerName,
                                                  email: b.email,
                                                }),
                                              },
                                            );

                                            const result =
                                              await response.json();

                                            setOpenMailMenu(null);

                                            if (result.success) {
                                              toast.update(loadingToast, {
                                                render:
                                                  " Confirm Booking email sent successfully!",
                                                type: "success",
                                                isLoading: false,
                                                autoClose: 3000,
                                              });
                                            } else {
                                              toast.update(loadingToast, {
                                                render:
                                                  " Failed: " +
                                                  (result.error ||
                                                    "Unknown error"),
                                                type: "error",
                                                isLoading: false,
                                                autoClose: 3000,
                                              });
                                            }
                                          } catch (error) {
                                            console.error(error);
                                            toast.error(" Error sending mail");
                                            setOpenMailMenu(null);
                                          }
                                        }}
                                        className="block w-full text-sm text-left px-2 py-2 border-t hover:bg-green-50 hover:rounded-b-lg group"
                                      >
                                        <span className="flex items-center gap-0.5">
                                          <LuArrowBigRightDash className="group-hover:fill-black" />
                                          Send Confirmation Mail
                                        </span>
                                      </button>
                                    </div>
                                  )}
                                </div>
                                {/* </Tooltip> */}

                                <Tooltip title="Delete" placement="top">
                                  <button
                                    onClick={() =>
                                      setDeletePopup({
                                        open: true,
                                        bookingid: b.id,
                                      })
                                    }
                                    className="pl-2 py-1 text-gray-400 hover:text-red-500 hover:scale-125 transition-all"
                                  >
                                    <MdDelete
                                      size={22}
                                      className="border border-red-300 rounded-full p-0.5"
                                    />
                                  </button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <nav
              className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
              aria-label="Table navigation"
            >
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {indexOfFirstTable_booking + 1}-
                  {Math.min(indexOfLastTable_booking, bookings.length)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {bookings.length}
                </span>
              </span>

              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={handlePrevPage_booking}
                    disabled={currentPage_booking === 1}
                    className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers_booking().map((page, index) =>
                  page === "..." ? (
                    <li
                      key={index}
                      className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7]"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={index}>
                      <button
                        onClick={() => handlePageChange_booking(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                          currentPage_booking === page
                            ? "text-green-500 underline underline-offset-2"
                            : ""
                        }`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={handleNextPage_booking}
                    disabled={currentPage_booking === totalPages_booking}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Bookings;

// // on going code
// import React, { useState, useEffect, useRef } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { Tooltip } from "antd";
// import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
// import { MdKeyboardDoubleArrowRight } from "react-icons/md";
// import { FaEdit, FaEye } from "react-icons/fa";
// import { MdCancel } from "react-icons/md";
// import { FiUploadCloud } from "react-icons/fi";
// import { MdDelete } from "react-icons/md";
// import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { format, parseISO, addDays } from "date-fns";
// import { GiNetworkBars } from "react-icons/gi";
// import { BsFillLuggageFill } from "react-icons/bs";
// import { FaMoneyBillTrendUp } from "react-icons/fa6";
// import axios from "axios";
// import { RiFileEditFill } from "react-icons/ri";
// import { IoIosMail } from "react-icons/io";
// import { LuArrowBigRightDash } from "react-icons/lu";
// import { useNavigate } from "react-router-dom";

// const Bookings = () => {
//   // Add this helper function at the top of your component, after the useState declarations
//   const [mailLoading, setMailLoading] = useState(false);

//   const formatDateForDisplay = (dateValue) => {
//     if (!dateValue) return "";

//     // If it's already a Date object
//     if (dateValue instanceof Date) {
//       const year = dateValue.getFullYear();
//       const month = String(dateValue.getMonth() + 1).padStart(2, "0");
//       const day = String(dateValue.getDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     }

//     // If it's a string
//     if (typeof dateValue === "string") {
//       // If it contains 'T' (ISO datetime), extract just the date part
//       if (dateValue.includes("T")) {
//         // Parse the date string and create a local date
//         const date = new Date(dateValue);
//         // Use local date methods to avoid timezone shift
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const day = String(date.getDate()).padStart(2, "0");
//         return `${year}-${month}-${day}`;
//       }

//       // If it's already YYYY-MM-DD, return as is
//       if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
//         return dateValue;
//       }
//     }

//     return dateValue;
//   };
//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));
//   const isAdmin = user?.role?.toLowerCase() === "admin";

//   const [loading, setLoading] = useState(true);
//   const [formMode, setFormMode] = useState("add");
//   const [bookings, setBookings] = useState([]);
//   const [dateFilter, setDateFilter] = useState({ from: "", to: "" });
//   const [isViewOnly, setIsViewOnly] = useState(false);

//   const [searchQuery, setSearchQuery] = useState("");
//   const [manualMode, setManualMode] = useState(false);
//   const [manualProperty, setManualProperty] = useState("");

//   const [deletePopup, setDeletePopup] = useState({
//     open: false,
//     bookingid: null,
//   });
//   const [editingBooking, setEditingBooking] = useState(null); // store booking being edited

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const savedState = localStorage.getItem("menubarOpen");

//     if (savedState !== null) {
//       return JSON.parse(savedState);
//     }

//     return window.innerWidth >= 1024;
//   });

//   const [formData, setFormData] = useState({
//     country: "",
//     state: "",
//     city: "",
//     gstnum: "",
//     totpay: "",
//     advpay: "",
//     balpay: "",
//     property: "",
//     rooms: 0,
//     guests: 0,
//     bookingstatus: "Pending", // Add default
//     paymentstatus: "Pending", // Add default
//   });
//   const [idproofFile, setidproofFile] = useState(null);
//   const [executives, setExecutives] = useState([]);
//   const [nameSuggestions, setNameSuggestions] = useState([]);
//   const [showNameSuggestions, setShowNameSuggestions] = useState(false);
//   const suggestionRef = useRef(null);
//   const [showGstConfirm, setShowGstConfirm] = useState(false);
//   const [pendingGstValue, setPendingGstValue] = useState(null);
//   useEffect(() => {
//     const fetchExecutives = async () => {
//       try {
//         const res = await fetch(
//           "https://dash.zorbastays.com/web-backend/users",
//         );
//         const data = await res.json();
//         setExecutives(data);
//       } catch (err) {
//         console.error("Error fetching executives:", err);
//       }
//     };

//     fetchExecutives();
//   }, []);
//   // inclusive of GST
//   const [isinclusive, setisinclusive] = useState(true);
//   const b2c = Number(formData.btocprice || 0);
//   const secdep = Number(formData.secdep || 0);
//   let baseprice = 0;
//   let cgst = 0;
//   let sgst = 0;
//   let total = 0;

//   if (b2c > 0) {
//     if (isinclusive) {
//       // Price already includes GST
//       baseprice = b2c / 1.18;
//       const gstAmount = b2c - baseprice;
//       cgst = gstAmount / 2;
//       sgst = gstAmount / 2;
//       total = b2c; //secdep
//     } else {
//       // Price does NOT include GST
//       baseprice = b2c;
//       cgst = baseprice * 0.09;
//       sgst = baseprice * 0.09;
//       total = baseprice + cgst + sgst; //secdep
//     }
//   }
//   // const handleChange = (e) => {
//   //   setFormData({ ...formData, [e.target.name]: e.target.value });
//   // };
//   const [worldData, setWorldData] = useState([]);

//   useEffect(() => {
//     // fetch from public/world.json
//     fetch("/world.json")
//       .then((res) => res.json())
//       .then((data) => setWorldData(data))
//       .catch((err) => console.error("Error loading world.json:", err));
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => {
//       const updated = { ...prev, [name]: value };

//       // 🌍 Reset dependent dropdowns
//       if (name === "country") {
//         updated.state = "";
//         updated.city = "";
//       } else if (name === "state") {
//         updated.city = "";
//       }

//       if (name === "proprice" || name === "checkin" || name === "checkout") {
//         const checkin = updated.checkin;
//         const checkout = updated.checkout;
//         const proprice = parseFloat(updated.proprice) || 0;

//         if (checkin && checkout && proprice > 0) {
//           const checkinDate = new Date(checkin);
//           const checkoutDate = new Date(checkout);
//           const nights = Math.max(
//             0,
//             Math.round((checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)),
//           );
//           updated.btocprice = (nights * proprice).toFixed(2);
//         }
//       }

//       // 💰 Auto-calculate balance when proprice or advance changes
//       // if (name === "proprice" || name === "advpay") {
//       //   const pro = parseFloat(updated.proprice) || 0;
//       //   const advance = parseFloat(updated.advpay) || 0;
//       //   updated.balpay = (pro - advance).toFixed(2);
//       //   // const total = parseFloat(updated.proprice) || 0;
//       //   // const advance = parseFloat(updated.advpay) || 0;
//       //   // updated.balpay = (total - advance).toFixed(2);
//       // }
//       return updated;
//     });
//     if (name === "firstname") {
//       // Clear any existing timeout
//       if (window.suggestionTimeout) {
//         clearTimeout(window.suggestionTimeout);
//       }

//       // Set new timeout for debounce
//       window.suggestionTimeout = setTimeout(() => {
//         fetchNameSuggestions(value);
//       }, 300); // Wait 300ms after user stops typing
//     }
//   };

//   // Find selected country object
//   const selectedCountry = worldData.find((c) => c.name === formData.country);

//   // Extract states
//   const states = selectedCountry?.states || [];

//   // Find selected state object
//   const selectedState = states.find((s) => s.name === formData.state);

//   // Extract cities
//   const cities = selectedState?.cities || [];
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setidproofFile(file); // save selected file
//     }
//   };
//   const fileInputRef = useRef(null);

//   const handleBoxClick = () => {
//     fileInputRef.current.click();
//   };

//   // put this near the top of your component (after useState for bookings)
//   const fetchBookings = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(
//         "https://dash.zorbastays.com/web-backend/bookings",
//       );
//       const data = await res.json();
//       setBookings(data);
//     } catch (err) {
//       console.error("Error fetching bookings:", err);
//     } finally {
//       setLoading(false); // hide loader after fetch
//     }
//   };

//   // then call it in useEffect
//   useEffect(() => {
//     fetchBookings();
//   }, []);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         suggestionRef.current &&
//         !suggestionRef.current.contains(event.target)
//       ) {
//         setShowNameSuggestions(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
//   const [dbBlockedDates, setDbBlockedDates] = useState([]);
//   const [airbnbBlockedDates, setAirbnbBlockedDates] = useState([]);

//   useEffect(() => {
//     if (!formData.property) return;
//     axios
//       .get(
//         `https://dash.zorbastays.com/web-backend/blocked-dates/${encodeURIComponent(formData.property)}`,
//       )
//       .then((res) => {
//         if (res.data.success) {
//           setDbBlockedDates(res.data.dbBlockedDates);
//           setAirbnbBlockedDates(res.data.airbnbBlockedDates);
//         }
//       })
//       .catch((err) => console.error("Failed to fetch blocked dates:", err));
//   }, [formData.property]);

//   const isDateBlocked = (date) => {
//     const str = format(date, "yyyy-MM-dd");
//     return dbBlockedDates.includes(str) || airbnbBlockedDates.includes(str);
//   };

//   const getDayClass = (date) => {
//     const str = format(date, "yyyy-MM-dd");
//     if (airbnbBlockedDates.includes(str)) return "airbnb-blocked-day";
//     if (dbBlockedDates.includes(str)) return "zorba-blocked-day";
//     return undefined;
//   };
//   const hasBlockedDateInRange = (checkoutDate) => {
//     if (!formData.checkin) return false;

//     const start = new Date(formData.checkin);
//     start.setDate(start.getDate() + 1); // day after checkin
//     const end = new Date(checkoutDate);

//     let current = new Date(start);
//     while (current < end) {
//       const str = format(current, "yyyy-MM-dd");
//       if (dbBlockedDates.includes(str) || airbnbBlockedDates.includes(str)) {
//         return true;
//       }
//       current.setDate(current.getDate() + 1);
//     }
//     return false;
//   };
//   // const handleSaveBooking = async () => {
//   //   if (!isAdmin) {
//   //     toast.error("Only admins can modify bookings.");
//   //     return;
//   //   }
//   //   const rooms = Number(formData.rooms) || 0;
//   //   const guests = Number(formData.guests) || 0;

//   //   if (rooms === 0 && guests === 0) {
//   //     toast.error("Rooms and Guests cannot be 0");
//   //     return;
//   //   }

//   //   if (rooms === 0) {
//   //     toast.error("Number of rooms cannot be 0");
//   //     return;
//   //   }

//   //   if (guests === 0) {
//   //     toast.error("Number of guests cannot be 0");
//   //     return;
//   //   }
//   //   let data = new FormData();

//   //   // Append formData fields (skip calculated ones — we'll add them fresh below)
//   //   const calculatedKeys = [
//   //     "cgst",
//   //     "sgst",
//   //     "totgst",
//   //     "baseprice",
//   //     "finalprice",
//   //     "profit",
//   //     "isinclusive",
//   //     "secdep",
//   //     "proprice",
//   //   ];

//   //   Object.keys(formData).forEach((key) => {
//   //     if (
//   //       key !== "bookingid" &&
//   //       !calculatedKeys.includes(key) &&
//   //       formData[key] !== undefined &&
//   //       formData[key] !== null
//   //     ) {
//   //       // Don't filter out empty strings for status fields
//   //       if (key === "bookingstatus" || key === "paymentstatus") {
//   //         data.append(key, formData[key] || "Pending");
//   //       } else if (formData[key] !== "") {
//   //         data.append(key, formData[key]);
//   //       }
//   //     }
//   //   });

//   //   if (idproofFile) {
//   //     data.append("idproof", idproofFile);
//   //   }

//   //   // ================================
//   //   // 🔥 GST CALCULATION LOGIC
//   //   // ================================
//   //   const b2c = Number(formData.btocprice || 0);
//   //   const b2b = Number(formData.btobprice || 0);
//   //   const secdepVal = Number(formData.secdep || 0);
//   //   const propriceVal = Number(formData.proprice || 0);

//   //   let baseprice = 0;
//   //   let cgst = 0;
//   //   let sgst = 0;
//   //   let total = 0;

//   //   if (isinclusive) {
//   //     baseprice = b2c / 1.18;
//   //     cgst = baseprice * 0.09;
//   //     sgst = baseprice * 0.09;
//   //     total = b2c + secdepVal;
//   //   } else {
//   //     baseprice = b2c;
//   //     cgst = baseprice * 0.09;
//   //     sgst = baseprice * 0.09;
//   //     total = baseprice + cgst + sgst + secdepVal;
//   //   }

//   //   const profit = b2c - b2b;

//   //   // Always append calculated fields fresh (single source of truth)
//   //   data.append("baseprice", baseprice.toFixed(2));
//   //   data.append("cgst", cgst.toFixed(2));
//   //   data.append("sgst", sgst.toFixed(2));
//   //   data.append("totgst", (cgst + sgst).toFixed(2));
//   //   data.append("finalprice", total.toFixed(2));
//   //   data.append("profit", profit.toFixed(2));
//   //   data.append("isinclusive", isinclusive.toString()); // always send as string "true"/"false"
//   //   data.append("secdep", secdepVal.toFixed(2));
//   //   data.append("proprice", propriceVal.toFixed(2));

//   //   try {
//   //     let url = "https://dash.zorbastays.com/web-backend/createBooking";
//   //     let method = "POST";

//   //     if (editingBooking) {
//   //       url = `https://dash.zorbastays.com/web-backend/bookings/${editingBooking.id}`;
//   //       method = "PUT";
//   //     }
//   //     console.log("FormData entries:", [...data.entries()]);
//   //     const res = await fetch(url, { method, body: data });
//   //     const result = await res.json();

//   //     if (result.success) {
//   //       toast.success(
//   //         editingBooking
//   //           ? "Booking updated successfully!"
//   //           : `Booking added successfully! ID: ${result.bookingid}`,
//   //       );

//   //       // if (editingBooking) {
//   //       //   setBookings((prev) =>
//   //       //     prev.map((bk) =>
//   //       //       bk.id === editingBooking.id ? { ...bk, ...formData, profit } : bk,
//   //       //     ),
//   //       //   );
//   //       // } else {
//   //       //   fetchBookings();
//   //       // }
//   //       fetchBookings();
//   //       handleClosePopup();
//   //       setEditingBooking(null);
//   //     } else {
//   //       toast.error("Please enter required fields");
//   //     }
//   //   } catch (err) {
//   //     console.error("Booking error:", err);
//   //     toast.error("Could not connect to server");
//   //   }
//   // };

//   const handleSaveBooking = async () => {
//     if (!isAdmin) {
//       toast.error("Only admins can modify bookings.");
//       return;
//     }
//     const rooms = Number(formData.rooms) || 0;
//     const guests = Number(formData.guests) || 0;

//     if (rooms === 0 && guests === 0) {
//       toast.error("Rooms and Guests cannot be 0");
//       return;
//     }

//     if (rooms === 0) {
//       toast.error("Number of rooms cannot be 0");
//       return;
//     }

//     if (guests === 0) {
//       toast.error("Number of guests cannot be 0");
//       return;
//     }
//     let data = new FormData();

//     // Append formData fields (skip calculated ones — we'll add them fresh below)
//     const calculatedKeys = [
//       "cgst",
//       "sgst",
//       "totgst",
//       "baseprice",
//       "finalprice",
//       "profit",
//       "isinclusive",
//       "secdep",
//       "proprice",
//     ];

//     Object.keys(formData).forEach((key) => {
//       if (
//         key !== "bookingid" &&
//         !calculatedKeys.includes(key) &&
//         formData[key] !== undefined &&
//         formData[key] !== null
//       ) {
//         // Don't filter out empty strings for status fields
//         if (key === "bookingstatus" || key === "paymentstatus") {
//           data.append(key, formData[key] || "Pending");
//         } else if (formData[key] !== "") {
//           // 🔥 CRITICAL FIX: Ensure dates are sent as YYYY-MM-DD strings only
//           if ((key === "checkin" || key === "checkout") && formData[key]) {
//             let dateStr = formData[key];

//             // If it's a Date object, convert to YYYY-MM-DD
//             if (dateStr instanceof Date) {
//               const year = dateStr.getFullYear();
//               const month = String(dateStr.getMonth() + 1).padStart(2, "0");
//               const day = String(dateStr.getDate()).padStart(2, "0");
//               dateStr = `${year}-${month}-${day}`;
//             }
//             // If it contains 'T', take only the date part
//             else if (typeof dateStr === "string" && dateStr.includes("T")) {
//               dateStr = dateStr.split("T")[0];
//             }
//             // If it's already YYYY-MM-DD, keep as is

//             data.append(key, dateStr);
//           } else {
//             data.append(key, formData[key]);
//           }
//         }
//       }
//     });

//     if (idproofFile) {
//       data.append("idproof", idproofFile);
//     }

//     // ================================
//     // 🔥 GST CALCULATION LOGIC
//     // ================================
//     const b2c = Number(formData.btocprice || 0);
//     const b2b = Number(formData.btobprice || 0);
//     const secdepVal = Number(formData.secdep || 0);
//     const propriceVal = Number(formData.proprice || 0);

//     let baseprice = 0;
//     let cgst = 0;
//     let sgst = 0;
//     let total = 0;

//     if (isinclusive) {
//       baseprice = b2c / 1.18;
//       cgst = baseprice * 0.09;
//       sgst = baseprice * 0.09;
//       total = b2c; //secdepVal
//     } else {
//       baseprice = b2c;
//       cgst = baseprice * 0.09;
//       sgst = baseprice * 0.09;
//       total = baseprice + cgst + sgst; //secdepVal
//     }

//     const profit = b2c - b2b;

//     // Always append calculated fields fresh (single source of truth)
//     data.append("baseprice", baseprice.toFixed(2));
//     data.append("cgst", cgst.toFixed(2));
//     data.append("sgst", sgst.toFixed(2));
//     data.append("totgst", (cgst + sgst).toFixed(2));
//     data.append("finalprice", total.toFixed(2));
//     data.append("profit", profit.toFixed(2));
//     data.append("isinclusive", isinclusive.toString());
//     data.append("secdep", secdepVal.toFixed(2));
//     data.append("proprice", propriceVal.toFixed(2));

//     try {
//       let url = "https://dash.zorbastays.com/web-backend/createBooking";
//       let method = "POST";

//       if (editingBooking) {
//         url = `https://dash.zorbastays.com/web-backend/bookings/${editingBooking.id}`;
//         method = "PUT";
//       }

//       // Debug: Log what's actually being sent
//       const formDataEntries = [...data.entries()];
//       console.log("📤 Sending FormData:");
//       formDataEntries.forEach(([key, value]) => {
//         console.log(`  ${key}:`, value);
//       });

//       const res = await fetch(url, { method, body: data });
//       const result = await res.json();

//       if (result.success) {
//         toast.success(
//           editingBooking
//             ? "Booking updated successfully!"
//             : `Booking added successfully! ID: ${result.bookingid}`,
//         );

//         fetchBookings();
//         handleClosePopup();
//         setEditingBooking(null);
//       } else {
//         toast.error("Please enter required fields");
//       }
//     } catch (err) {
//       console.error("Booking error:", err);
//       toast.error("Could not connect to server");
//     }
//   };
//   const resetForm = () => {
//     setFormData({
//       country: "",
//       state: "",
//       city: "",
//       bookingstatus: "Pending", // Add default
//       paymentstatus: "Pending", // Add default
//     });
//     setidproofFile(null);
//     setisinclusive(true);
//     setEditingBooking(null);
//   };

//   const handleClosePopup = () => {
//     setIsOpen_popupForm(false);
//     resetForm();
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // const navigate = useNavigate();

//   // const [selected_filter, setSelected_filter] = useState("Today");

//   // const [active_filter, setActive_filter] = useState(false);

//   // const toggleAll_filter = () => {
//   //   setActive_filter((prev_filter) => !prev_filter);
//   // };

//   const statusColors = {
//     CANCELLED: "bg-amber-800/20 text-amber-800",
//     CONFIRMED: "bg-green-500/20 text-green-500",
//     BOOKED: "bg-purple-500/20 text-purple-500",
//     FAILED: "bg-red-500/20 text-red-500",
//     PENDING: "bg-yellow-200/40 text-yellow-300",
//     PAID: "bg-transparent text-green-500",
//     UNPAID: "bg-transparent text-red-400",
//     PROCESSING: "bg-pink-200/40 text-pink-300",
//   };

//   const rowsPerPage_booking = 20;
//   const [currentPage_booking, setCurrentPage_booking] = useState(1);
//   //   const [selectedRows_booking, setSelectedRows_booking] = useState([]);

//   const indexOfLastTable_booking = currentPage_booking * rowsPerPage_booking;
//   const indexOfFirstTable_booking =
//     indexOfLastTable_booking - rowsPerPage_booking;

//   // const current_booking = bookings.slice(
//   //   indexOfFirstTable_booking,
//   //   indexOfLastTable_booking,
//   // );
//   // const totalPages_booking = Math.ceil(bookings.length / rowsPerPage_booking);

//   const handlePageChange_booking = (pageNumber_booking) => {
//     setCurrentPage_booking(pageNumber_booking);
//     // setSelectedRows_booking([]);
//   };

//   const handleNextPage_booking = () => {
//     if (currentPage_booking < totalPages_booking) {
//       setCurrentPage_booking(currentPage_booking + 1);
//     }
//   };

//   const handlePrevPage_booking = () => {
//     if (currentPage_booking > 1) {
//       setCurrentPage_booking(currentPage_booking - 1);
//     }
//   };

//   const generatePageNumbers_booking = () => {
//     const pageNumbers_booking = [];

//     if (totalPages_booking <= 3) {
//       for (let i = 1; i <= totalPages_booking; i++) {
//         pageNumbers_booking.push(i);
//       }
//     } else {
//       if (currentPage_booking > 2) {
//         pageNumbers_booking.push(1);
//         pageNumbers_booking.push("...");
//       }
//       for (let i = currentPage_booking - 1; i <= currentPage_booking + 1; i++) {
//         if (i > 0 && i <= totalPages_booking) {
//           pageNumbers_booking.push(i);
//         }
//       }
//       if (currentPage_booking < totalPages_booking - 1) {
//         pageNumbers_booking.push("...");
//         pageNumbers_booking.push(totalPages_booking);
//       }
//     }
//     return pageNumbers_booking;
//   };

//   const [selectedRows_booking, setSelectedRows_booking] = useState([]);

//   const handleRowCheckboxChange_booking = (order) => {
//     setSelectedRows_booking((prevSelected) =>
//       prevSelected.includes(order)
//         ? prevSelected.filter((id) => id !== order)
//         : [...prevSelected, order],
//     );
//   };

//   const handleSelectAll_booking = () => {
//     if (selectedRows_booking.length === current_booking.length) {
//       setSelectedRows_booking([]);
//     } else {
//       setSelectedRows_booking(current_booking.map((booking) => booking.order));
//     }
//   };

//   const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowPopup_filter(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
//   // when popup opens, set default bookingtime
//   useEffect(() => {
//     if (isOpen_popupForm) {
//       setFormData((prev) => ({
//         ...prev,
//         bookingtime: new Date().toISOString(), // ISO format (safe for DB)
//       }));
//     }
//   }, [isOpen_popupForm]);
//   const [properties, setProperties] = useState([]);

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         const res = await fetch(
//           "https://dash.zorbastays.com/web-backend/properties",
//         );
//         const data = await res.json();
//         setProperties(data);
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//       }
//     };

//     fetchProperties();
//   }, []);

//   const handleDeleteBooking = async (id) => {
//     if (!isAdmin) {
//       toast.error("🚫 Only admins can modify bookings.");
//       return;
//     }

//     try {
//       const res = await fetch(
//         `https://dash.zorbastays.com/web-backend/bookings/${id}`,
//         { method: "DELETE" },
//       );
//       const result = await res.json();

//       if (result.success) {
//         toast.success(" Booking deleted successfully");
//         setBookings((prev) => prev.filter((b) => b.id !== id));
//         setDeletePopup({ open: false, bookingid: null }); // close popup
//       } else {
//         toast.error("Failed to delete: " + (result.error || "Unknown error"));
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Could not connect to server");
//     }
//   };
//   const [isOpen, setIsOpen] = useState(false);
//   const [search, setSearch] = useState("");
//   const dropdownRef = useRef(null);

//   // close when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // sort alphabetically
//   const sortedProperties = [...properties].sort((a, b) =>
//     a.propertyname.localeCompare(b.propertyname),
//   );

//   // filter by search
//   const filteredProperties = sortedProperties.filter((p) =>
//     p.propertyname.toLowerCase().includes(search.toLowerCase()),
//   );
//   const normalizeDate = (dateStr) => {
//     if (!dateStr) return null;
//     const d = new Date(dateStr);
//     d.setHours(0, 0, 0, 0);
//     return d;
//   };

//   // const filteredBookings = current_booking.filter((b) => {
//   //   const query = searchQuery.toLowerCase();

//   //   //  text-based search (Booking ID, Name, destination)
//   //   const matchesSearch =
//   //     (b.bookingid && b.bookingid.toString().toLowerCase().includes(query)) ||
//   //     `${b.firstname} ${b.lastname}`.toLowerCase().includes(query) ||
//   //     (b.destination && b.destination.toLowerCase().includes(query));

//   //   //  check-in date filter only
//   //   let matchesDate = true;
//   //   const checkinDate = normalizeDate(b.checkin);
//   //   const fromDate = normalizeDate(dateFilter.from);
//   //   const toDate = normalizeDate(dateFilter.to);

//   //   if (fromDate) {
//   //     matchesDate = matchesDate && checkinDate >= fromDate;
//   //   }
//   //   if (toDate) {
//   //     matchesDate = matchesDate && checkinDate <= toDate;
//   //   }

//   //   return matchesSearch && matchesDate;
//   // });
//   // 1. Filter ALL bookings (not just current page)
//   // 1. Filter ALL bookings globally
//   const filteredBookings = bookings.filter((b) => {
//     const query = searchQuery.toLowerCase();

//     const matchesSearch =
//       (b.bookingid && b.bookingid.toString().toLowerCase().includes(query)) ||
//       `${b.firstname} ${b.lastname}`.toLowerCase().includes(query) ||
//       (b.destination && b.destination.toLowerCase().includes(query));

//     let matchesDate = true;
//     const checkinDate = normalizeDate(b.checkin);
//     const fromDate = normalizeDate(dateFilter.from);
//     const toDate = normalizeDate(dateFilter.to);

//     if (fromDate) matchesDate = matchesDate && checkinDate >= fromDate;
//     if (toDate) matchesDate = matchesDate && checkinDate <= toDate;

//     return matchesSearch && matchesDate;
//   });

//   // 2. Paginate filtered results
//   const totalPages_booking = Math.ceil(
//     filteredBookings.length / rowsPerPage_booking,
//   );
//   const current_booking = filteredBookings.slice(
//     indexOfFirstTable_booking,
//     indexOfLastTable_booking,
//   );

//   useEffect(() => {
//     setCurrentPage_booking(1);
//   }, [searchQuery, dateFilter]);
//   const today = new Date();
//   const setQuickFilter = (type) => {
//     let from, to;

//     if (type === "Today") {
//       from = to = today.toISOString().split("T")[0];
//     }

//     if (type === "Week") {
//       const start = new Date(today);
//       start.setDate(today.getDate() - today.getDay()); // start of week (Sunday)
//       const end = new Date(start);
//       end.setDate(start.getDate() + 6); // end of week (Saturday)

//       from = start.toISOString().split("T")[0];
//       to = end.toISOString().split("T")[0];
//     }

//     if (type === "Month") {
//       const start = new Date(today.getFullYear(), today.getMonth(), 1);
//       const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);

//       from = start.toISOString().split("T")[0];
//       to = end.toISOString().split("T")[0];
//     }

//     if (type === "Year") {
//       const start = new Date(today.getFullYear(), 0, 1);
//       const end = new Date(today.getFullYear(), 11, 31);

//       from = start.toISOString().split("T")[0];
//       to = end.toISOString().split("T")[0];
//     }

//     setDateFilter({ from, to });
//   };
//   const [analytics, setAnalytics] = useState({
//     totalRevenue: 0,
//     pendingPayments: 0,
//     profit: 0,
//   });

//   useEffect(() => {
//     const fetchAnalytics = async () => {
//       try {
//         const res = await axios.get(
//           "https://dash.zorbastays.com/web-backend/getBookingAnalytics",
//         );
//         if (res.data.success) {
//           setAnalytics(res.data.analytics);
//         }
//       } catch (err) {
//         console.error(" Error fetching analytics:", err);
//       }
//     };

//     fetchAnalytics();
//   }, []);

//   // format numbers with commas
//   const formatNumber = (num) =>
//     new Intl.NumberFormat("en-IN").format(Number(num));
//   const [bookedByDate, setBookedByDate] = useState({});

//   useEffect(() => {
//     const fetchBookedDates = async () => {
//       try {
//         const res = await fetch(
//           "https://dash.zorbastays.com/web-backend/getBookingsByDateProp",
//         );
//         const data = await res.json();
//         if (data.success) setBookedByDate(data.bookings);
//       } catch (err) {
//         console.error("Error fetching booked dates:", err);
//       }
//     };
//     fetchBookedDates();
//   }, []);

//   // helper to expand date range
//   const getDatesInRange = (start, end) => {
//     const dates = [];
//     let current = new Date(start);
//     const last = new Date(end);
//     while (current <= last) {
//       dates.push(current.toISOString().split("T")[0]); // yyyy-mm-dd
//       current.setDate(current.getDate() + 1);
//     }
//     return dates;
//   };

//   const [openMailMenu, setOpenMailMenu] = useState(null);
//   // const dropdownRef_mail = useRef(null);

//   // Close when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Check if the click is on any mail button or inside any dropdown
//       const isMailButton = event.target.closest(".mail-button");
//       const isDropdown = event.target.closest(".mail-dropdown");

//       if (!isMailButton && !isDropdown) {
//         setOpenMailMenu(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const fetchNameSuggestions = async (firstname) => {
//     if (!firstname || firstname.length < 2) {
//       setNameSuggestions([]);
//       setShowNameSuggestions(false);
//       return;
//     }

//     try {
//       const res = await fetch(
//         `https://dash.zorbastays.com/web-backend/searchBookingsByName?firstname=${encodeURIComponent(firstname)}`,
//       );
//       const data = await res.json();

//       if (data.success && data.bookings.length > 0) {
//         // Group by firstname + lastname to show unique combinations
//         const uniqueNames = [];
//         const seen = new Set();

//         data.bookings.forEach((booking) => {
//           const key = `${booking.firstname}|${booking.lastname}`;
//           if (!seen.has(key) && booking.firstname) {
//             seen.add(key);
//             uniqueNames.push(booking);
//           }
//         });

//         setNameSuggestions(uniqueNames);
//         setShowNameSuggestions(uniqueNames.length > 0);
//       } else {
//         setNameSuggestions([]);
//         setShowNameSuggestions(false);
//       }
//     } catch (err) {
//       console.error("Error fetching name suggestions:", err);
//       setNameSuggestions([]);
//       setShowNameSuggestions(false);
//     }
//   };
//   const handleSelectNameSuggestion = (booking) => {
//     setFormData((prev) => ({
//       ...prev,
//       firstname: booking.firstname || "",
//       lastname: booking.lastname || "",
//       email: booking.email || "",
//       phone: booking.phone || "",
//       country: booking.country || "",
//       state: booking.state || "",
//       city: booking.city || "",
//       // Optionally fill other fields if you want
//       // gstnum: booking.gstnum || "",
//       // destination: booking.destination || "",
//     }));

//     setShowNameSuggestions(false);
//     setNameSuggestions([]);
//   };

//   const handleSendInvoice = async (b) => {
//     const customerName = `${b.firstname} ${b.lastname}`;

//     // ✅ CONFIRM POPUP
//     const confirmSend = window.confirm(
//       `Do you want to send "Mail Invoice" to ${customerName}?`,
//     );
//     if (!confirmSend) return;

//     try {
//       const loadingToast = toast.loading("Sending Invoice...");

//       const response = await fetch(
//         "https://dash.zorbastays.com/web-backend/sendInvoiceEmail",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             bookingid: b.bookingid,
//             customerName,
//             email: b.email,
//           }),
//         },
//       );

//       const data = await response.json();

//       setOpenMailMenu(null);

//       if (data.success) {
//         toast.update(loadingToast, {
//           render: "✅ Invoice sent successfully!",
//           type: "success",
//           isLoading: false,
//           autoClose: 3000,
//         });
//       } else {
//         toast.update(loadingToast, {
//           render: "❌ Failed: " + data.message,
//           type: "error",
//           isLoading: false,
//           autoClose: 3000,
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("⚠️ Error sending invoice");
//       setOpenMailMenu(null);
//     }
//   };

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Bookings
//             </p>

//             {/* <div className="flex flex-col sm:flex-row gap-3 items-start lg:items-center">
//               <div className="flex items-center pl-2 border border-black rounded-lg">
//                 <IoMdTime className="text-lg" />

//                 <select
//                   name="filter"
//                   value={selected_filter}
//                   onChange={(e) => setSelected_filter(e.target.value)}
//                   className="block text-center text-xs bg-transparent focus:outline-none focus:ring-0 border-none focus:border-none"
//                   style={{ appearance: "none" }}
//                 >
//                   <option key="" value="Today">
//                     Today
//                   </option>
//                   <option key="" value="Week">
//                     This Week
//                   </option>
//                   <option key="" value="Custom">
//                     Custom
//                   </option>
//                 </select>
//               </div>

//               <div className="flex items-center gap-3">
//                 <div
//                   onClick={toggleAll_filter}
//                   className="flex flex-col items-center gap-4 pl-2 cursor-pointer select-none group scale-[0.8]"
//                 >
//                   <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full ">
//                     <div
//                       className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                       style={{
//                         left: active_filter ? "100%" : "0%",
//                         transform: `translate(${
//                           active_filter ? "-100%" : "0"
//                         }, -50%)`,
//                       }}
//                     ></div>
//                   </div>

//                   <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
//                     <div
//                       className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                       style={{
//                         left: active_filter ? "0%" : "100%",
//                         transform: `translate(${
//                           active_filter ? "0" : "-100%"
//                         }, -50%)`,
//                       }}
//                     ></div>
//                   </div>

//                   <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                     <div
//                       className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                       style={{
//                         left: active_filter ? "100%" : "0%",
//                         transform: `translate(${
//                           active_filter ? "-100%" : "0"
//                         }, -50%)`,
//                       }}
//                     ></div>
//                   </div>
//                 </div>

//                 <div className="-mr-1">
//                   <button className="Btn">
//                     <svg
//                       className="svgIcon"
//                       viewBox="0 0 384 512"
//                       height="1em"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
//                     </svg>
//                     <span className="icon2"></span>
//                     <span className="tooltip text-sm">Download</span>
//                   </button>
//                 </div>

//                 <div className="p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//                   <div className="flex items-center justify-center fill-[#1D2826]">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       id="Isolation_Mode"
//                       data-name="Isolation Mode"
//                       viewBox="0 0 24 24"
//                       width="18"
//                       height="18"
//                     >
//                       <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
//                     </svg>
//                   </div>
//                   <input
//                     type="text"
//                     className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//                   />
//                 </div>
//               </div>
//             </div> */}
//           </div>

//           <div className="flex items-center gap-1">
//             <div className="flex items-center">
//               {/* Search bar */}
//               <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//                 {/* Search icon */}
//                 <div className="flex items-center justify-center fill-[#1D2826]">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 24 24"
//                     width="18"
//                     height="18"
//                   >
//                     <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
//                   </svg>
//                 </div>

//                 {/* Input */}
//                 <input
//                   type="text"
//                   placeholder="Search..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//                 />

//                 {/* Clear button */}
//                 {searchQuery && (
//                   <button
//                     onClick={() => setSearchQuery("")}
//                     className="text-gray-500 hover:text-black text-lg font-bold px-1"
//                   >
//                     ×
//                   </button>
//                 )}
//               </div>

//               <div className="">
//                 <button className="Btn">
//                   <svg
//                     className="svgIcon"
//                     viewBox="0 0 384 512"
//                     height="1em"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
//                   </svg>
//                   <span className="icon2"></span>
//                   <span className="tooltip text-sm">Download</span>
//                 </button>
//               </div>

//               <div className="flex items-center">
//                 <div className="relative inline-block" ref={filterRef}>
//                   <div
//                     onClick={() => setShowPopup_filter((prev) => !prev)}
//                     className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
//                       showPopup_filter
//                         ? "border-[#1D2826]"
//                         : "border-transparent hover:border-[#1D2826]"
//                     }`}
//                   >
//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "0%" : "100%",
//                           transform: `translate(${
//                             showPopup_filter ? "0" : "-100%"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   {showPopup_filter && (
//                     <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4 w-64">
//                       <h3 className="text-sm font-semibold text-gray-700 mb-2">
//                         Filter out on Check-In Date
//                       </h3>
//                       {/* Quick buttons */}
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             onClick={() => setQuickFilter(label)}
//                             className="flex-1 py-1 px-2 bg-gray-100 hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>

//                       {/* Custom date range */}
//                       <div className="flex flex-col gap-2">
//                         <div className="flex items-center gap-2">
//                           <DatePicker
//                             selected={
//                               dateFilter.from ? parseISO(dateFilter.from) : null
//                             }
//                             onChange={(date) =>
//                               setDateFilter((prev) => ({
//                                 ...prev,
//                                 from: date ? format(date, "yyyy-MM-dd") : "",
//                               }))
//                             }
//                             dateFormat="dd-MM-yyyy" // 👈 shows as dd-MM-yyyy
//                             placeholderText="dd-mm-yyyy"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                           <span className="text-sm text-gray-500">-</span>
//                           <DatePicker
//                             selected={
//                               dateFilter.to ? parseISO(dateFilter.to) : null
//                             }
//                             onChange={(date) =>
//                               setDateFilter((prev) => ({
//                                 ...prev,
//                                 to: date ? format(date, "yyyy-MM-dd") : "",
//                               }))
//                             }
//                             dateFormat="dd-MM-yyyy"
//                             placeholderText="dd-mm-yyyy"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                         </div>
//                       </div>

//                       {/* Apply & Reset */}
//                       <div className="flex justify-end gap-2 pt-2">
//                         <button
//                           onClick={() => setDateFilter({ from: "", to: "" })}
//                           className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded"
//                         >
//                           Reset
//                         </button>
//                         <button
//                           onClick={() => setShowPopup_filter(false)}
//                           className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
//                         >
//                           Apply
//                         </button>
//                       </div>
//                     </div>
//                   )}

//                   {deletePopup.open && (
//                     <>
//                       {/* Overlay */}
//                       <div
//                         className="fixed inset-0 bg-black bg-opacity-40 z-40"
//                         onClick={() =>
//                           setDeletePopup({ open: false, bookingid: null })
//                         }
//                       />

//                       {/* Popup box */}
//                       <div className="fixed top-1/2 left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-lg w-[90%] max-w-md p-6 text-center">
//                         <h2 className="text-lg font-semibold text-gray-800 mb-3">
//                           Delete Booking?
//                         </h2>
//                         <p className="text-sm text-gray-500 mb-6">
//                           Are you sure you want to delete this booking? This
//                           action cannot be undone.
//                         </p>

//                         <div className="flex justify-center gap-4">
//                           <button
//                             onClick={() =>
//                               setDeletePopup({ open: false, bookingid: null })
//                             }
//                             className="px-5 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
//                           >
//                             Cancel
//                           </button>

//                           <button
//                             onClick={() =>
//                               handleDeleteBooking(deletePopup.bookingid)
//                             }
//                             className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Boxes */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Total Revenue</p>
//               <p className="mt-2 text-lg text-black">
//                 ₹{formatNumber(analytics.totalRevenue)}
//                 <sup className="text-green-500">+55%</sup>
//               </p>
//             </div>

//             <div>
//               <GiNetworkBars className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>

//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Pending Payments</p>
//               <p className="mt-2 text-lg text-black">
//                 ₹{formatNumber(analytics.pendingPayments)}
//                 <sup className="text-green-500">+5%</sup>
//               </p>
//             </div>

//             <div>
//               <BsFillLuggageFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>

//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Revenue by Property</p>
//               <p className="mt-2 text-lg text-black">
//                 ₹{formatNumber(analytics.profit)}
//                 <sup className="text-green-500">+8%</sup>
//               </p>
//             </div>

//             <div>
//               <FaMoneyBillTrendUp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>
//         </div>

//         {/* Button */}
//         <div className="flex justify-end mt-8">
//           {isAdmin && (
//             <button
//               onClick={() => {
//                 setFormMode("add");
//                 //---------------//
//                 setIsViewOnly(false);
//                 setEditingBooking(null);
//                 resetForm();
//                 setisinclusive(true);
//                 //---------------//
//                 setIsOpen_popupForm(true);
//               }}
//               className="px-6 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//               // className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 transition-all ease-linear duration-200"
//             >
//               + Add Booking
//             </button>
//           )}

//           <div className="relative z-50">
//             {isOpen_popupForm && (
//               <div
//                 onClick={handleClosePopup}
//                 className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
//               />
//             )}

//             <div
//               className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
//                 isOpen_popupForm ? "translate-x-0" : "translate-x-full"
//               } panel_popupForm`}
//             >
//               <div className="p-4 flex justify-between items-center border-b header_popupForm">
//                 <h2 className="text-[#1D2826] text-lg font-semibold">
//                   {formMode === "add" && "Add New Booking"}
//                   {formMode === "edit" && "Edit Booking"}
//                   {formMode === "view" && "View Booking"}
//                 </h2>

//                 <div className="flex gap-3">
//                   {formMode === "view" && (
//                     <button
//                       onClick={() => {
//                         setFormMode("edit");
//                         setIsViewOnly(false);
//                         setisinclusive(
//                           editingBooking?.isinclusive === 1 ||
//                             editingBooking?.isinclusive === "1" ||
//                             editingBooking?.isinclusive === true ||
//                             editingBooking?.isinclusive === "true",
//                         );
//                       }}
//                       className="flex items-center gap-1 text-xs px-4 py-2 bg-green-900 text-white rounded-lg hover:opacity-90"
//                     >
//                       <FaEdit />
//                       Edit Booking
//                     </button>
//                   )}

//                   <button
//                     onClick={handleClosePopup}
//                     className="text-gray-500 hover:text-black text-xl"
//                   >
//                     <MdCancel />
//                   </button>
//                 </div>
//               </div>

//               <div className="p-4">
//                 <div className="font-semibold text-gray-500 text-sm text-right">
//                   <input
//                     type="checkbox"
//                     id="isPackageBooking"
//                     name="isPackageBooking"
//                     checked={formData.isPackageBooking || false}
//                     onChange={(e) =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         isPackageBooking: e.target.checked,
//                       }))
//                     }
//                     className="h-4 w-4 text-green-600 border-gray-400 rounded focus:ring-0 focus:border-black"
//                   />
//                   <label
//                     htmlFor="isPackageBooking"
//                     className="text-sm font-medium text-gray-700"
//                   >
//                     &nbsp; &nbsp;Does this booking belong to a package?
//                   </label>
//                   {/* Booking ID: <span className="text-black my-1">10294837</span> */}
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
//                   {/* First Name */}
//                   <div
//                     className="flex flex-col w-full relative"
//                     ref={suggestionRef}
//                   >
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       First Name <sub className="text-red-500 text-base">*</sub>
//                     </label>
//                     <input
//                       placeholder="Enter first name"
//                       required
//                       name="firstname"
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       value={formData.firstname || ""}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                       autoComplete="off"
//                     />
//                     {/* Suggestions Dropdown */}
//                     {showNameSuggestions && nameSuggestions.length > 0 && (
//                       <div className="absolute z-50 top-full left-0 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                         {nameSuggestions.map((suggestion, index) => (
//                           <div
//                             key={index}
//                             onClick={() =>
//                               handleSelectNameSuggestion(suggestion)
//                             }
//                             className="px-4 py-3 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
//                           >
//                             <div className="font-medium">
//                               {suggestion.firstname} {suggestion.lastname}
//                             </div>
//                             <div className="text-xs text-gray-500 mt-1">
//                               {suggestion.email && (
//                                 <span className="mr-3">{suggestion.email}</span>
//                               )}
//                               {suggestion.phone && (
//                                 <span>{suggestion.phone}</span>
//                               )}
//                             </div>
//                             <div className="text-xs text-gray-400 mt-1">
//                               {suggestion.county && suggestion.city
//                                 ? `${suggestion.city}, ${suggestion.country}`
//                                 : suggestion.country || suggestion.city || ""}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                   {/* Last Name */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Last Name <sub className="text-red-500 text-base">*</sub>
//                     </label>
//                     <input
//                       placeholder="Enter last name"
//                       required
//                       name="lastname"
//                       value={formData.lastname || ""}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       onChange={handleChange}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Email */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Email <sub className="text-red-500 text-base">*</sub>
//                     </label>
//                     <input
//                       placeholder="Enter your email"
//                       required
//                       name="email"
//                       value={formData.email || ""}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       onChange={handleChange}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Phone Number */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Phone Number
//                     </label>
//                     <input
//                       placeholder="Enter phone number"
//                       required
//                       name="phone"
//                       value={formData.phone || ""}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       onChange={handleChange}
//                       maxLength={10}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Country */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "view" ? "z-10" : "z-0"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
//                     >
//                       Country
//                     </label>
//                     <select
//                       name="country"
//                       value={formData.country}
//                       onChange={handleChange}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
//                     >
//                       <option value="">Select your country</option>
//                       {worldData.map((country) => (
//                         <option key={country.id} value={country.name}>
//                           {country.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   {/* State */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "edit" ? "z-0" : "z-10"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative z-10 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       State
//                     </label>
//                     <select
//                       name="state"
//                       value={formData.state || ""}
//                       onChange={handleChange}
//                       disabled={isViewOnly || !formData.country}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
//                     >
//                       <option value="">Select your state</option>
//                       {states.map((state) => (
//                         <option key={state.id} value={state.name}>
//                           {state.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   {/* City */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "edit" ? "z-0" : "z-10"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative z-10 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       City
//                     </label>
//                     <select
//                       name="city"
//                       value={formData.city || ""}
//                       onChange={handleChange}
//                       disabled={isViewOnly || !formData.state}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:border-black"
//                     >
//                       <option value="">Select your city</option>
//                       {cities.map((city) => (
//                         <option key={city.id} value={city.name}>
//                           {city.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   {/* Booking Date & Time */}
//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Booking Date & Time
//                     </label>
//                     <input
//                       type="text"
//                       name="bookingtime"
//                       readOnly
//                       value={
//                         formData.bookingtime
//                           ? new Date(formData.bookingtime).toLocaleString()
//                           : ""
//                       }
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md text-black"
//                     />
//                   </div>
//                   {/* Check In Date */}
//                   {/* <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="checkin"
//                       className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Check In Date
//                     </label>

//                     <DatePicker
//                       selected={
//                         formData.checkin
//                           ? (() => {
//                               // If it's already a Date object, return it
//                               if (formData.checkin instanceof Date) {
//                                 return formData.checkin;
//                               }
//                               // If the string contains 'T' (has time component), parse as is
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 formData.checkin.includes("T")
//                               ) {
//                                 return new Date(formData.checkin);
//                               }
//                               // If it's just YYYY-MM-DD, parse it as local date (not UTC)
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
//                               ) {
//                                 const [year, month, day] = formData.checkin
//                                   .split("-")
//                                   .map(Number);
//                                 return new Date(year, month - 1, day); // month is 0-indexed
//                               }
//                               // Fallback
//                               return new Date(formData.checkin);
//                             })()
//                           : null
//                       }
//                       onChange={(date) => {
//                         const newcheckin = date
//                           ? format(date, "yyyy-MM-dd")
//                           : "";
//                         setFormData((prev) => ({
//                           ...prev,
//                           checkin: newcheckin,
//                           checkout: "",
//                           btocprice: "",
//                         }));
//                       }}
//                       dateFormat="dd-MM-yyyy"
//                       minDate={new Date()}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
//                       placeholderText="dd-mm-yyyy"
//                       disabled={isViewOnly}
//                     />
//                   </div> */}

//                   {/* Check Out Date */}
//                   {/* <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="checkout"
//                       className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Check Out Date
//                     </label>

//                     <DatePicker
//                       selected={
//                         formData.checkout
//                           ? (() => {
//                               // If it's already a Date object, return it
//                               if (formData.checkout instanceof Date) {
//                                 return formData.checkout;
//                               }
//                               // If the string contains 'T' (has time component), parse as is
//                               if (
//                                 typeof formData.checkout === "string" &&
//                                 formData.checkout.includes("T")
//                               ) {
//                                 return new Date(formData.checkout);
//                               }
//                               // If it's just YYYY-MM-DD, parse it as local date (not UTC)
//                               if (
//                                 typeof formData.checkout === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkout)
//                               ) {
//                                 const [year, month, day] = formData.checkout
//                                   .split("-")
//                                   .map(Number);
//                                 return new Date(year, month - 1, day); // month is 0-indexed
//                               }
//                               // Fallback
//                               return new Date(formData.checkout);
//                             })()
//                           : null
//                       }
//                       onChange={(date) => {
//                         const newcheckout = date
//                           ? format(date, "yyyy-MM-dd")
//                           : "";
//                         setFormData((prev) => {
//                           const proprice = parseFloat(prev.proprice) || 0;
//                           const checkin = prev.checkin;
//                           let btocprice = prev.btocprice;

//                           if (checkin && newcheckout && proprice > 0) {
//                             // Parse checkin as local date
//                             let checkinDate;
//                             if (
//                               typeof checkin === "string" &&
//                               /^\d{4}-\d{2}-\d{2}$/.test(checkin)
//                             ) {
//                               const [y, m, d] = checkin.split("-").map(Number);
//                               checkinDate = new Date(y, m - 1, d);
//                             } else {
//                               checkinDate = new Date(checkin);
//                             }

//                             // Parse checkout as local date
//                             let checkoutDate;
//                             if (
//                               typeof newcheckout === "string" &&
//                               /^\d{4}-\d{2}-\d{2}$/.test(newcheckout)
//                             ) {
//                               const [y, m, d] = newcheckout
//                                 .split("-")
//                                 .map(Number);
//                               checkoutDate = new Date(y, m - 1, d);
//                             } else {
//                               checkoutDate = new Date(newcheckout);
//                             }

//                             const nights = Math.max(
//                               0,
//                               Math.round(
//                                 (checkoutDate - checkinDate) /
//                                   (1000 * 60 * 60 * 24),
//                               ),
//                             );
//                             btocprice = (nights * proprice).toFixed(2);
//                           }

//                           return { ...prev, checkout: newcheckout, btocprice };
//                         });
//                       }}
//                       dateFormat="dd-MM-yyyy"
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
//                       placeholderText={
//                         !formData.checkin
//                           ? "Select check-in first"
//                           : "dd-mm-yyyy"
//                       }
//                       disabled={!formData.checkin || isViewOnly}
//                       minDate={
//                         formData.checkin
//                           ? (() => {
//                               // Parse checkin as local date
//                               let checkinDate;
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
//                               ) {
//                                 const [y, m, d] = formData.checkin
//                                   .split("-")
//                                   .map(Number);
//                                 checkinDate = new Date(y, m - 1, d);
//                               } else {
//                                 checkinDate = new Date(formData.checkin);
//                               }
//                               // Add 1 day to prevent same-day checkout
//                               checkinDate.setDate(checkinDate.getDate() + 1);
//                               return checkinDate;
//                             })()
//                           : null
//                       }
//                     />
//                   </div> */}

//                   {/* Check In Date */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="checkin"
//                       className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Check In Date
//                     </label>

//                     <DatePicker
//                       selected={
//                         formData.checkin
//                           ? (() => {
//                               if (formData.checkin instanceof Date)
//                                 return formData.checkin;
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 formData.checkin.includes("T")
//                               )
//                                 return new Date(formData.checkin);
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
//                               ) {
//                                 const [year, month, day] = formData.checkin
//                                   .split("-")
//                                   .map(Number);
//                                 return new Date(year, month - 1, day);
//                               }
//                               return new Date(formData.checkin);
//                             })()
//                           : null
//                       }
//                       onChange={(date) => {
//                         const newcheckin = date
//                           ? format(date, "yyyy-MM-dd")
//                           : "";
//                         setFormData((prev) => ({
//                           ...prev,
//                           checkin: newcheckin,
//                           checkout: "",
//                           btocprice: "",
//                         }));
//                       }}
//                       dateFormat="dd-MM-yyyy"
//                       minDate={new Date()}
//                       filterDate={(date) => !isDateBlocked(date)}
//                       dayClassName={getDayClass}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
//                       // placeholderText="dd-mm-yyyy"
//                       disabled={isViewOnly || !formData.property}
//                       placeholderText={
//                         !formData.property
//                           ? "Select a property first"
//                           : "dd-mm-yyyy"
//                       }
//                     />
//                   </div>

//                   {/* Check Out Date */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="checkout"
//                       className="text-gray-400 text-xs font-semibold relative z-20 top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Check Out Date
//                     </label>

//                     <DatePicker
//                       selected={
//                         formData.checkout
//                           ? (() => {
//                               if (formData.checkout instanceof Date)
//                                 return formData.checkout;
//                               if (
//                                 typeof formData.checkout === "string" &&
//                                 formData.checkout.includes("T")
//                               )
//                                 return new Date(formData.checkout);
//                               if (
//                                 typeof formData.checkout === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkout)
//                               ) {
//                                 const [year, month, day] = formData.checkout
//                                   .split("-")
//                                   .map(Number);
//                                 return new Date(year, month - 1, day);
//                               }
//                               return new Date(formData.checkout);
//                             })()
//                           : null
//                       }
//                       onChange={(date) => {
//                         const newcheckout = date
//                           ? format(date, "yyyy-MM-dd")
//                           : "";
//                         setFormData((prev) => {
//                           const proprice = parseFloat(prev.proprice) || 0;
//                           const checkin = prev.checkin;
//                           let btocprice = prev.btocprice;

//                           if (checkin && newcheckout && proprice > 0) {
//                             let checkinDate;
//                             if (
//                               typeof checkin === "string" &&
//                               /^\d{4}-\d{2}-\d{2}$/.test(checkin)
//                             ) {
//                               const [y, m, d] = checkin.split("-").map(Number);
//                               checkinDate = new Date(y, m - 1, d);
//                             } else {
//                               checkinDate = new Date(checkin);
//                             }

//                             let checkoutDate;
//                             if (
//                               typeof newcheckout === "string" &&
//                               /^\d{4}-\d{2}-\d{2}$/.test(newcheckout)
//                             ) {
//                               const [y, m, d] = newcheckout
//                                 .split("-")
//                                 .map(Number);
//                               checkoutDate = new Date(y, m - 1, d);
//                             } else {
//                               checkoutDate = new Date(newcheckout);
//                             }

//                             const nights = Math.max(
//                               0,
//                               Math.round(
//                                 (checkoutDate - checkinDate) /
//                                   (1000 * 60 * 60 * 24),
//                               ),
//                             );
//                             btocprice = (nights * proprice).toFixed(2);
//                           }

//                           return { ...prev, checkout: newcheckout, btocprice };
//                         });
//                       }}
//                       dateFormat="dd-MM-yyyy"
//                       filterDate={(date) =>
//                         !isDateBlocked(date) && !hasBlockedDateInRange(date)
//                       }
//                       dayClassName={getDayClass}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none focus:ring-0 focus:border-black focus:shadow-md"
//                       placeholderText={
//                         !formData.checkin
//                           ? "Select check-in first"
//                           : "dd-mm-yyyy"
//                       }
//                       disabled={!formData.checkin || isViewOnly}
//                       minDate={
//                         formData.checkin
//                           ? (() => {
//                               let checkinDate;
//                               if (
//                                 typeof formData.checkin === "string" &&
//                                 /^\d{4}-\d{2}-\d{2}$/.test(formData.checkin)
//                               ) {
//                                 const [y, m, d] = formData.checkin
//                                   .split("-")
//                                   .map(Number);
//                                 checkinDate = new Date(y, m - 1, d);
//                               } else {
//                                 checkinDate = new Date(formData.checkin);
//                               }
//                               checkinDate.setDate(checkinDate.getDate() + 1);
//                               return checkinDate;
//                             })()
//                           : null
//                       }
//                     />
//                   </div>

//                   {/* Booking status */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "view" ? "z-10" : "z-0"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
//                     >
//                       Booking Status
//                     </label>

//                     <select
//                       name="bookingstatus"
//                       value={formData.bookingstatus} // controlled value
//                       onChange={handleChange}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     >
//                       {/* <option value="">Select booking status</option> */}
//                       <option value="Pending">Pending</option>
//                       <option value="Booked">Booked</option>
//                       <option value="Cancelled">Cancelled</option>
//                       <option value="Processing">Processing</option>
//                     </select>
//                   </div>
//                   {/* Payment Status */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "view" ? "z-10" : "z-0"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
//                     >
//                       Payment Status
//                     </label>

//                     <select
//                       name="paymentstatus"
//                       value={formData.paymentstatus} // controlled value
//                       onChange={handleChange}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     >
//                       {/* <option value="">Select payment status</option> */}
//                       <option value="Paid">Paid</option>
//                       <option value="Pending">Pending</option>
//                       <option value="Cancelled">Cancelled</option>
//                     </select>
//                   </div>
//                   {/* Trip Executive */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       className={`text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit ${
//                         formMode === "view" ? "z-10" : "z-0"
//                       }`}
//                       // className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit z-10"
//                     >
//                       Trip Executive
//                     </label>

//                     <select
//                       name="tripexecutive"
//                       value={formData.tripexecutive || ""}
//                       onChange={handleChange}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     >
//                       <option value="">Select Trip Executive</option>
//                       {executives.map((exec, idx) => (
//                         <option key={idx} value={exec.name}>
//                           {exec.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   {/* destination */}
//                   <div
//                     className={`flex flex-col w-full ${
//                       formData.isPackageBooking
//                         ? "sm:col-span-1"
//                         : "sm:col-span-1"
//                     }`}
//                   >
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       destination
//                     </label>
//                     <input
//                       placeholder="Enter destination"
//                       required
//                       name="destination"
//                       value={formData.destination || ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Property Dropdown */}
//                   <div
//                     className="flex flex-col w-full relative"
//                     ref={dropdownRef}
//                   >
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Property
//                     </label>

//                     {/* Display selected value */}
//                     <div
//                       onClick={() => {
//                         if (!isViewOnly) {
//                           setIsOpen(!isOpen);
//                         }
//                       }}
//                       className={`border-gray-400 p-3 text-sm border rounded-lg w-full cursor-pointer focus:outline-none ${
//                         isViewOnly
//                           ? "bg-gray-100 cursor-not-allowed"
//                           : "bg-white"
//                       }`}
//                     >
//                       {formData.property || "Select a property"}
//                     </div>

//                     {isOpen && !isViewOnly && (
//                       <div className="absolute z-20 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                         {/* Toggle for Add Property */}
//                         <div className="flex items-center justify-between px-3 py-2 border-b bg-gray-50">
//                           <span className="text-sm font-semibold text-gray-600">
//                             Select or Add Property
//                           </span>
//                           <button
//                             type="button"
//                             onClick={() => setManualMode((prev) => !prev)}
//                             className="text-blue-600 text-xs font-medium hover:underline"
//                           >
//                             {manualMode ? "← Back to list" : "+ Add manually"}
//                           </button>
//                         </div>

//                         {/* Search / Manual Input */}
//                         <div className="flex items-center p-2 border-b">
//                           {manualMode ? (
//                             <input
//                               type="text"
//                               placeholder="Enter property name"
//                               className="w-full p-2 text-sm border rounded focus:outline-none"
//                               value={manualProperty}
//                               onChange={(e) =>
//                                 setManualProperty(e.target.value)
//                               }
//                               onKeyDown={(e) => {
//                                 if (
//                                   e.key === "Enter" &&
//                                   manualProperty.trim()
//                                 ) {
//                                   setFormData((prev) => ({
//                                     ...prev,
//                                     property: manualProperty.trim(),
//                                     checkin: "",
//                                     checkout: "",
//                                     btocprice: "",
//                                   }));
//                                   setDbBlockedDates([]); // 👈 clear old blocked dates
//                                   setAirbnbBlockedDates([]); // 👈 clear old blocked dates
//                                   setIsOpen(false);
//                                   setManualMode(false);
//                                   setManualProperty("");
//                                 }
//                               }}
//                             />
//                           ) : (
//                             <input
//                               type="text"
//                               placeholder="Type a property"
//                               className="w-full p-2 text-sm border rounded focus:outline-none"
//                               value={search}
//                               onChange={(e) => setSearch(e.target.value)}
//                             />
//                           )}
//                         </div>

//                         {/* List */}
//                         {!manualMode && (
//                           <ul className="max-h-48 overflow-y-auto">
//                             {filteredProperties.length > 0 ? (
//                               filteredProperties.map((p) => {
//                                 let isUnavailable = false;

//                                 if (formData.checkin && formData.checkout) {
//                                   const selectedDates = getDatesInRange(
//                                     formData.checkin,
//                                     formData.checkout,
//                                   );

//                                   isUnavailable = selectedDates.some((date) => {
//                                     const bookingsForDate =
//                                       bookedByDate[date] || [];
//                                     return bookingsForDate.some(
//                                       (b) =>
//                                         b.property === p.propertyname &&
//                                         (!editingBooking ||
//                                           b.bookingid !==
//                                             editingBooking.bookingid),
//                                     );
//                                   });
//                                 }

//                                 return (
//                                   <li
//                                     key={p.id}
//                                     // onClick={() => {
//                                     //   if (isUnavailable) return;
//                                     //   handleChange({
//                                     //     target: {
//                                     //       name: "property",
//                                     //       value: p.propertyname,
//                                     //     },
//                                     //   });
//                                     //   setIsOpen(false);
//                                     //   setSearch("");
//                                     // }}
//                                     onClick={() => {
//                                       if (isUnavailable) return;

//                                       const selectedProperty = properties.find(
//                                         (prop) =>
//                                           prop.propertyname === p.propertyname,
//                                       );

//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         property: p.propertyname,
//                                         rooms: selectedProperty?.maxbed ?? 0,
//                                         guests: selectedProperty?.maxadult ?? 0,
//                                         checkin: "", // 👈 reset dates
//                                         checkout: "", // 👈 reset dates
//                                         btocprice: "", // 👈 reset calculated price
//                                       }));

//                                       setIsOpen(false);
//                                       setSearch("");
//                                     }}
//                                     className={`px-4 py-2 text-sm ${
//                                       isUnavailable
//                                         ? "text-gray-400 cursor-not-allowed line-through"
//                                         : "hover:bg-gray-100 cursor-pointer"
//                                     }`}
//                                     title={
//                                       isUnavailable
//                                         ? "This property is already booked"
//                                         : ""
//                                     }
//                                   >
//                                     {p.propertyname}
//                                   </li>
//                                 );
//                               })
//                             ) : (
//                               <li className="px-4 py-2 text-gray-400 text-sm">
//                                 No results found
//                               </li>
//                             )}
//                           </ul>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                   {/* Property Price */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="proprice"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Property Price (Per Night)
//                     </label>
//                     <input
//                       type="text"
//                       step="0.01"
//                       placeholder="Enter total amount"
//                       name="proprice"
//                       value={formData.proprice || ""}
//                       // onChange={handleChange}
//                       onChange={(e) => {
//                         const value = e.target.value;

//                         // Allow only numbers and one decimal point
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleChange(e);
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Number of Room */}
//                   {/* <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Number of Rooms
//                     </label>
//                     <input
//                       type="number"
//                       placeholder="Enter No. Rooms"
//                       name="rooms"
//                       value={formData.rooms ?? ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div> */}
//                   {/* Number of Guests */}
//                   {/* <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Number of Guests
//                     </label>
//                     <input
//                       type="number"
//                       placeholder="Enter No. Guests"
//                       name="guests"
//                       value={formData.guests ?? ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div> */}
//                   {/* Number of Room */}
//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Number of Rooms{" "}
//                       <sub className="text-red-500 text-base">*</sub>
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       placeholder="Enter No. Rooms"
//                       name="rooms"
//                       value={formData.rooms ?? ""}
//                       onChange={(e) => {
//                         const { name, value } = e.target;
//                         // Only allow numbers
//                         if (value === "" || /^[0-9]+$/.test(value)) {
//                           setFormData((prev) => ({
//                             ...prev,
//                             [name]: value === "" ? "" : parseInt(value, 10),
//                           }));
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>

//                   {/* Number of Guests */}
//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Number of Guests{" "}
//                       <sub className="text-red-500 text-base">*</sub>
//                     </label>
//                     <input
//                       type="text"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       placeholder="Enter No. Guests"
//                       name="guests"
//                       value={formData.guests ?? ""}
//                       onChange={(e) => {
//                         const { name, value } = e.target;
//                         // Only allow numbers
//                         if (value === "" || /^[0-9]+$/.test(value)) {
//                           setFormData((prev) => ({
//                             ...prev,
//                             [name]: value === "" ? "" : parseInt(value, 10),
//                           }));
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Advance Payment */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="advpay"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Advance Payment
//                     </label>
//                     <input
//                       type="text"
//                       step="0.01"
//                       placeholder="Enter advance payment"
//                       name="advpay"
//                       value={formData.advpay || ""}
//                       // onChange={handleChange}
//                       onChange={(e) => {
//                         const value = e.target.value;

//                         // Allow only numbers and one decimal point
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleChange(e);
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Balance Amount */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="balpay"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Balance Amount
//                     </label>
//                     <input
//                       // type="number"
//                       // step="0.01"
//                       // placeholder="Enter balance amount"
//                       // name="balpay"
//                       // value={formData.balpay || ""}
//                       // onChange={handleChange}
//                       // readOnly={isViewOnly}
//                       // disabled={isViewOnly}
//                       type="text"
//                       step="0.01"
//                       placeholder="Enter balance amount"
//                       name="balpay"
//                       value={formData.balpay || ""}
//                       //  onChange={handleChange}
//                       onChange={(e) => {
//                         const value = e.target.value;

//                         // Allow only numbers and one decimal point
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleChange(e);
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Price Shown to Bussiness */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       B2B Price
//                     </label>
//                     <input
//                       placeholder="Enter B2B Price"
//                       name="btobprice"
//                       value={formData.btobprice || ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Price Shown to Customer */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       B2C Price
//                     </label>
//                     <input
//                       placeholder="Enter B2C Price"
//                       name="btocprice"
//                       value={formData.btocprice || ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Inclusive of GST */}
//                   <div className="font-semibold text-gray-500 text-sm ">
//                     <input
//                       type="checkbox"
//                       checked={isinclusive}
//                       // onChange={(e) => setisinclusive(e.target.checked)}
//                       onChange={(e) => {
//                         const newValue = e.target.checked;

//                         // If trying to uncheck (from true to false)
//                         if (isinclusive === true && newValue === false) {
//                           setPendingGstValue(false);
//                           setShowGstConfirm(true);
//                         } else {
//                           // If checking (from false to true), just update
//                           setisinclusive(newValue);
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="h-4 w-4 text-green-600 border-gray-400 rounded focus:ring-0 focus:border-black"
//                     />
//                     <label
//                       htmlFor=""
//                       className="text-sm font-medium text-gray-700"
//                     >
//                       &nbsp; &nbsp;Inclusive GST
//                     </label>
//                   </div>
//                   {/* GST Confirmation Popup */}
//                   {showGstConfirm && (
//                     <>
//                       {/* Overlay */}
//                       <div
//                         className="fixed inset-0 bg-black bg-opacity-30 z-[60]"
//                         onClick={() => setShowGstConfirm(false)}
//                       />

//                       {/* Popup */}
//                       <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-lg z-[70] w-[90%] max-w-md p-6">
//                         <h3 className="text-lg font-semibold text-gray-800 mb-3">
//                           Confirm GST Change
//                         </h3>

//                         <p className="text-sm text-gray-600 mb-6">
//                           By unchecking this, 18% GST will be added to the total
//                           price. Are you sure you want to continue?
//                         </p>

//                         <div className="flex justify-end gap-3">
//                           <button
//                             onClick={() => {
//                               setShowGstConfirm(false);
//                               setPendingGstValue(null);
//                             }}
//                             className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
//                           >
//                             Cancel
//                           </button>

//                           <button
//                             onClick={() => {
//                               setisinclusive(pendingGstValue);
//                               setShowGstConfirm(false);
//                               setPendingGstValue(null);
//                             }}
//                             className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
//                           >
//                             OK
//                           </button>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                   {/*  Profit Display */}
//                   <div>
//                     {formData.btocprice && formData.btobprice && (
//                       <p className="text-green-600 text-sm mt-1">
//                         Profit revenue for this booking: ₹
//                         {Number(formData.btocprice || 0) -
//                           Number(formData.btobprice || 0)}
//                       </p>
//                     )}
//                   </div>

//                   {/*  CGST Display Make sure user cant write it should be autofilled */}
//                   {/* <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       CGST (9%)
//                     </label>
//                     <input
//                       placeholder="0"
//                       name=""
//                       value={cgst.toFixed(2)}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div> */}
//                   {/*  SGST Display Make sure user cant write it should be autofilled */}
//                   {/* <div className="flex flex-col w-full ">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       SGST (9%)
//                     </label>
//                     <input
//                       placeholder="0"
//                       name="gstnum"
//                       value={sgst.toFixed(2)}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div> */}
//                   {!isinclusive ? (
//                     <>
//                       {/* CGST Display */}
//                       <div className="flex flex-col w-full">
//                         <label
//                           htmlFor="input"
//                           className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                         >
//                           CGST (9%)
//                         </label>
//                         <input
//                           placeholder="0"
//                           value={cgst.toFixed(2)}
//                           readOnly={isViewOnly}
//                           disabled={isViewOnly}
//                           className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                         />
//                       </div>
//                       {/* SGST Display */}
//                       <div className="flex flex-col w-full">
//                         <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                           SGST (9%)
//                         </label>
//                         <input
//                           placeholder="0"
//                           value={sgst.toFixed(2)}
//                           readOnly={isViewOnly}
//                           disabled={isViewOnly}
//                           className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     // When Inclusive is checked, add empty divs to maintain grid
//                     <>
//                       <div className="hidden sm:block"></div>
//                       <div className="hidden sm:block"></div>
//                     </>
//                   )}
//                   {/* Security Deposit */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       htmlFor="secdep"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Security Deposit
//                     </label>
//                     <input
//                       type="text"
//                       step="0.01"
//                       placeholder="Enter security deposit"
//                       name="secdep"
//                       value={formData.secdep || ""}
//                       // onChange={handleChange}
//                       onChange={(e) => {
//                         const value = e.target.value;

//                         // Allow only numbers and one decimal point
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleChange(e);
//                         }
//                       }}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Total Price */}
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Total Price
//                     </label>
//                     <input
//                       name=""
//                       value={total.toFixed(2)}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* GST Number */}
//                   <div className="flex flex-col w-full ">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       GST Number
//                     </label>
//                     <input
//                       placeholder="Enter GST Number"
//                       name="gstnum"
//                       value={formData.gstnum || ""}
//                       onChange={handleChange}
//                       readOnly={isViewOnly}
//                       disabled={isViewOnly}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>
//                   {/* Package input (only if checkbox is checked) */}
//                   {formData.isPackageBooking && (
//                     <div className="flex flex-col w-full">
//                       <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                         Package
//                       </label>
//                       <input
//                         placeholder="Enter package name"
//                         name="package"
//                         value={formData.package || ""}
//                         onChange={handleChange}
//                         readOnly={isViewOnly}
//                         disabled={isViewOnly}
//                         className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                       />
//                     </div>
//                   )}
//                   <div className="flex flex-col w-full sm:col-span-2">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       ID Proof
//                     </label>

//                     {isViewOnly ? (
//                       editingBooking?.idproof ? (
//                         <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
//                           <a
//                             href={`https://dash.zorbastays.com/web-backend/bookings/${editingBooking?.id}/idproof`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="px-3 py-1 bg-green-600 text-white rounded text-sm"
//                           >
//                             Download
//                           </a>
//                         </div>
//                       ) : (
//                         // ✅ View mode: no file → show message
//                         <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
//                           <p className="text-sm text-red-500">
//                             ID Proof was not uploaded
//                           </p>
//                         </div>
//                       )
//                     ) : editingBooking?.idproof ? (
//                       // ✅ Edit mode: file exists → download + replace
//                       <div className="flex flex-col items-start gap-2 p-3 border rounded-lg">
//                         <p className="text-sm text-gray-700">
//                           Existing file uploaded
//                         </p>
//                         <div className="flex gap-3">
//                           <a
//                             href={`https://dash.zorbastays.com/web-backend/bookings/${editingBooking?.id}/idproof`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="px-3 py-1 bg-green-600 text-white rounded text-sm"
//                           >
//                             Download
//                           </a>
//                           <button
//                             onClick={handleBoxClick}
//                             type="button"
//                             className="px-3 py-1 bg-gray-700 text-white rounded text-sm"
//                           >
//                             Replace File
//                           </button>
//                         </div>
//                       </div>
//                     ) : (
//                       // ✅ Edit mode: no file yet → upload
//                       <div
//                         onClick={handleBoxClick}
//                         className="border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center text-center p-6 cursor-pointer hover:border-black transition-all"
//                       >
//                         <FiUploadCloud className="w-10 h-10 text-green-600 mb-2" />
//                         <p className="text-sm font-medium text-black">
//                           {idproofFile
//                             ? idproofFile.name
//                             : "Select File to Upload"}
//                         </p>
//                         <p className="text-xs text-gray-400">Image or PDF</p>
//                       </div>
//                     )}

//                     {!isViewOnly && (
//                       <input
//                         ref={fileInputRef}
//                         type="file"
//                         accept="image/*,.pdf"
//                         className="hidden"
//                         onChange={handleFileChange}
//                       />
//                     )}
//                   </div>
//                   <div className="grid grid-cols-2 gap-3">
//                     <button
//                       onClick={handleClosePopup}
//                       className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       onClick={handleSaveBooking}
//                       className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//                     >
//                       Save
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* <a
//             href="/BookingCalendar"
//             className="px-6 z-30 py-2 bg-gray-500 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//           >
//             Booking Calendar
//           </a> */}
//         </div>

//         {/* Table */}
//         <div>
//           <div className="shadow-md rounded-lg mt-5">
//             {loading ? (
//               <div className="flex justify-center items-center py-10">
//                 <div className="w-10 h-10 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
//                 <span className="ml-3 text-gray-600">Loading bookings...</span>
//               </div>
//             ) : (
//               <>
//                 <div className="overflow-x-auto">
//                   <table className="w-full text-sm text-left rtl:text-right text-gray-500">
//                     <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                       <tr>
//                         <th className="p-4">
//                           <input
//                             type="checkbox"
//                             onChange={handleSelectAll_booking}
//                             checked={
//                               selectedRows_booking.length ===
//                                 current_booking.length &&
//                               current_booking.length > 0
//                             }
//                           />
//                         </th>
//                         <th className="p-4 w-1/12">Booking ID</th>
//                         <th className="p-4 w-1/10">Customer Name</th>
//                         <th className="p-4 w-1/10">Property Code</th>
//                         <th className="p-4 w-1/10">Package / destination</th>
//                         <th className="p-4 w-1/10">Booking Date</th>
//                         <th className="p-4 w-1/10">Check-In Date</th>
//                         <th className="p-4 w-1/10">Check-Out Date</th>
//                         <th className="p-4 w-1/10">Status</th>
//                         <th className="p-4 w-1/10">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredBookings.map((b) => (
//                         <tr
//                           key={b.id || b.bookingid}
//                           className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
//                         >
//                           {/* Checkbox */}
//                           <td className="px-4 py-3">
//                             <input
//                               type="checkbox"
//                               onChange={() =>
//                                 handleRowCheckboxChange_booking(
//                                   b.id || b.bookingid,
//                                 )
//                               }
//                               checked={selectedRows_booking.includes(
//                                 b.id || b.bookingid,
//                               )}
//                             />
//                           </td>
//                           {/* Booking ID */}
//                           <td className="px-4 py-3 font-semibold text-gray-700">
//                             {b.bookingid || "-"}
//                           </td>
//                           {/* Customer Name */}
//                           <td className="px-4 py-3">
//                             <Tooltip
//                               title={`${b.firstname} ${b.lastname}`}
//                               placement="left"
//                             >
//                               {b.firstname} {b.lastname}
//                             </Tooltip>
//                           </td>

//                           {/* Property Code */}
//                           <td className="px-4 py-3">
//                             <Tooltip title={`${b.property}`} placement="left">
//                               {b.property}
//                             </Tooltip>
//                           </td>

//                           {/* destination */}
//                           <td className="px-4 py-3">
//                             <Tooltip
//                               title={
//                                 b.package
//                                   ? `${b.package}-${b.destination}`
//                                   : b.destination || "-"
//                               }
//                               placement="left"
//                             >
//                               {b.package
//                                 ? `${b.package}-${b.destination}`
//                                 : b.destination || "-"}
//                             </Tooltip>
//                           </td>

//                           {/* Booking Date */}
//                           <td className="px-4 py-3">
//                             <Tooltip title={b.bookingtime} placement="left">
//                               {b.bookingtime
//                                 ? new Date(b.bookingtime).toLocaleDateString(
//                                     "en-GB",
//                                   )
//                                 : "-"}
//                             </Tooltip>
//                           </td>

//                           {/* Check-In */}
//                           <td className="px-4 py-3">
//                             <Tooltip
//                               title={
//                                 b.checkin
//                                   ? new Date(b.checkin).toLocaleDateString(
//                                       "en-GB",
//                                     ) // dd/mm/yyyy
//                                   : "-"
//                               }
//                               placement="left"
//                             >
//                               {b.checkin
//                                 ? new Date(b.checkin).toLocaleDateString(
//                                     "en-GB",
//                                   )
//                                 : "-"}
//                             </Tooltip>
//                           </td>

//                           {/* Check-Out */}
//                           <td className="px-4 py-3">
//                             <Tooltip
//                               title={
//                                 b.checkout
//                                   ? new Date(b.checkout).toLocaleDateString(
//                                       "en-GB",
//                                     )
//                                   : "-"
//                               }
//                               placement="left"
//                             >
//                               {b.checkout
//                                 ? new Date(b.checkout).toLocaleDateString(
//                                     "en-GB",
//                                   )
//                                 : "-"}
//                             </Tooltip>
//                           </td>
//                           {/* Status */}
//                           <td className="px-4 py-3 text-center">
//                             <div className="flex justify-between items-center">
//                               <button
//                                 className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
//                                   statusColors[
//                                     b.bookingstatus?.toUpperCase()
//                                   ] || ""
//                                 }`}
//                               >
//                                 {b.bookingstatus || "PENDING"}
//                               </button>
//                             </div>
//                           </td>

//                           {/* Actions */}
//                           <td>
//                             <div className="grid grid-cols-2 gap-y-1 my-2">
//                               {/* Everyone can view */}
//                               <Tooltip title="View Booking" placement="top">
//                                 <button
//                                   className="relative group pl-4 py-1 text-gray-400 hover:text-sky-500 hover:scale-125 transition-all"
//                                   onClick={() => {
//                                     setEditingBooking(b);

//                                     // 🔥 Format dates using the helper function
//                                     const formattedcheckin =
//                                       formatDateForDisplay(b.checkin);
//                                     const formattedcheckout =
//                                       formatDateForDisplay(b.checkout);

//                                     console.log(
//                                       "Original checkin:",
//                                       b.checkin,
//                                       "Formatted:",
//                                       formattedcheckin,
//                                     );
//                                     console.log(
//                                       "Original checkout:",
//                                       b.checkout,
//                                       "Formatted:",
//                                       formattedcheckout,
//                                     );

//                                     setFormData({
//                                       ...b,
//                                       isPackageBooking: !!b.package,
//                                       bookingtime: b.bookingtime
//                                         ? new Date(b.bookingtime).toISOString()
//                                         : new Date().toISOString(),
//                                       checkin: formattedcheckin,
//                                       checkout: formattedcheckout,
//                                       proprice: b.proprice || "",
//                                       secdep: b.secdep || "",
//                                     });

//                                     setisinclusive(
//                                       b.isinclusive === 1 ||
//                                         b.isinclusive === "1" ||
//                                         b.isinclusive === true ||
//                                         b.isinclusive === "true",
//                                     );
//                                     setFormMode("view");
//                                     setIsViewOnly(true);
//                                     setIsOpen_popupForm(true);
//                                   }}
//                                 >
//                                   <FaEye
//                                     size={22}
//                                     className="border border-sky-300 rounded-full p-0.5"
//                                   />
//                                 </button>
//                               </Tooltip>

//                               {/* Only admins can edit/delete */}
//                               {isAdmin && (
//                                 <>
//                                   <Tooltip title="Feedback" placement="top">
//                                     <button
//                                       onClick={() =>
//                                         navigate(`/FeedbackForm/${b.id}`, {
//                                           state: { from: "bookings" },
//                                         })
//                                       }
//                                       className="pl-2 py-1 text-gray-400 hover:text-yellow-300 hover:scale-125 transition-all"
//                                     >
//                                       <RiFileEditFill
//                                         size={22}
//                                         className="border border-yellow-300 rounded-full p-0.5"
//                                       />
//                                     </button>
//                                   </Tooltip>

//                                   {/* <Tooltip title="Send Mail" placement="top"> */}
//                                   <div className="relative inline-block">
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation();
//                                         e.preventDefault();
//                                         console.log(
//                                           "🔵 Mail button clicked for booking ID:",
//                                           b.id,
//                                         );

//                                         // Toggle this specific dropdown
//                                         setOpenMailMenu(
//                                           openMailMenu === b.id ? null : b.id,
//                                         );
//                                       }}
//                                       className="pl-4 py-1 text-gray-400 hover:text-purple-500 hover:scale-125 transition-all mail-button"
//                                     >
//                                       <IoIosMail
//                                         size={23}
//                                         className="border border-purple-300 rounded-full p-0.5"
//                                       />
//                                     </button>

//                                     {openMailMenu === b.id && (
//                                       <div className="absolute right-0 mt-0 w-48 bg-white border rounded-lg rounded-tr-none shadow-custom z-50 mail-dropdown">
//                                         <button
//                                           className="block w-full text-sm text-left px-2 py-2 border-b hover:bg-green-50 hover:rounded-t-lg group"
//                                           onClick={async (e) => {
//                                             e.preventDefault();
//                                             e.stopPropagation();

//                                             const customerName = `${b.firstname} ${b.lastname}`;

//                                             const confirmSend = window.confirm(
//                                               `Do you want to send "Proforma Invoice" to ${customerName}?`,
//                                             );
//                                             if (!confirmSend) return;

//                                             try {
//                                               const loadingToast =
//                                                 toast.loading(
//                                                   "Sending Proforma Invoice email...",
//                                                 );

//                                               const response = await fetch(
//                                                 `https://dash.zorbastays.com/web-backend/bookings/${b.id}/send-email`,
//                                                 {
//                                                   method: "POST",
//                                                   headers: {
//                                                     "Content-Type":
//                                                       "application/json",
//                                                   },
//                                                   body: JSON.stringify({
//                                                     type: "pre-booking",
//                                                     bookingid: b.bookingid,
//                                                     customerName,
//                                                     email: b.email,
//                                                   }),
//                                                 },
//                                               );

//                                               const result =
//                                                 await response.json();

//                                               setOpenMailMenu(null);

//                                               if (result.success) {
//                                                 toast.update(loadingToast, {
//                                                   render:
//                                                     "✅ Proforma Invoice sent successfully!",
//                                                   type: "success",
//                                                   isLoading: false,
//                                                   autoClose: 3000,
//                                                 });
//                                               } else {
//                                                 toast.update(loadingToast, {
//                                                   render:
//                                                     "❌ Failed: " +
//                                                     (result.error ||
//                                                       "Unknown error"),
//                                                   type: "error",
//                                                   isLoading: false,
//                                                   autoClose: 3000,
//                                                 });
//                                               }
//                                             } catch (error) {
//                                               console.error(error);
//                                               toast.error(
//                                                 "⚠️ Error sending mail",
//                                               );
//                                               setOpenMailMenu(null);
//                                             }
//                                           }}
//                                         >
//                                           <span className="flex items-center gap-0.5">
//                                             <LuArrowBigRightDash className="group-hover:fill-black" />
//                                             Mail Proforma Invoice
//                                           </span>
//                                         </button>

//                                         <button
//                                           className="block w-full text-sm text-left px-2 py-2 hover:bg-green-50 group"
//                                           onClick={() => handleSendInvoice(b)}
//                                         >
//                                           <span className="flex items-center gap-0.5">
//                                             <LuArrowBigRightDash className="group-hover:fill-black" />
//                                             Mail Invoice
//                                           </span>
//                                         </button>

//                                         <button
//                                           onClick={async (e) => {
//                                             e.preventDefault();
//                                             e.stopPropagation();

//                                             const customerName = `${b.firstname} ${b.lastname}`;

//                                             const confirmSend = window.confirm(
//                                               `Do you want to send "Confirm  Booking" to ${customerName}?`,
//                                             );
//                                             if (!confirmSend) return;

//                                             try {
//                                               const loadingToast =
//                                                 toast.loading(
//                                                   "Sending Confirm Booking email...",
//                                                 );

//                                               const response = await fetch(
//                                                 `https://dash.zorbastays.com/web-backend/confirmBookings/${b.id}/send-email`,
//                                                 {
//                                                   method: "POST",
//                                                   headers: {
//                                                     "Content-Type":
//                                                       "application/json",
//                                                   },
//                                                   body: JSON.stringify({
//                                                     type: "pre-booking",
//                                                     bookingid: b.bookingid,
//                                                     customerName,
//                                                     email: b.email,
//                                                   }),
//                                                 },
//                                               );

//                                               const result =
//                                                 await response.json();

//                                               setOpenMailMenu(null);

//                                               if (result.success) {
//                                                 toast.update(loadingToast, {
//                                                   render:
//                                                     "✅ Confirm Booking email sent successfully!",
//                                                   type: "success",
//                                                   isLoading: false,
//                                                   autoClose: 3000,
//                                                 });
//                                               } else {
//                                                 toast.update(loadingToast, {
//                                                   render:
//                                                     "❌ Failed: " +
//                                                     (result.error ||
//                                                       "Unknown error"),
//                                                   type: "error",
//                                                   isLoading: false,
//                                                   autoClose: 3000,
//                                                 });
//                                               }
//                                             } catch (error) {
//                                               console.error(error);
//                                               toast.error(
//                                                 "⚠️ Error sending mail",
//                                               );
//                                               setOpenMailMenu(null);
//                                             }
//                                           }}
//                                           className="block w-full text-sm text-left px-2 py-2 border-t hover:bg-green-50 hover:rounded-b-lg group"
//                                         >
//                                           <span className="flex items-center gap-0.5">
//                                             <LuArrowBigRightDash className="group-hover:fill-black" />
//                                             Send Confirmation Mail
//                                           </span>
//                                         </button>
//                                       </div>
//                                     )}
//                                   </div>
//                                   {/* </Tooltip> */}

//                                   <Tooltip title="Delete" placement="top">
//                                     <button
//                                       onClick={() =>
//                                         setDeletePopup({
//                                           open: true,
//                                           bookingid: b.id,
//                                         })
//                                       }
//                                       className="pl-2 py-1 text-gray-400 hover:text-red-500 hover:scale-125 transition-all"
//                                     >
//                                       <MdDelete
//                                         size={22}
//                                         className="border border-red-300 rounded-full p-0.5"
//                                       />
//                                     </button>
//                                   </Tooltip>
//                                 </>
//                               )}
//                             </div>
//                           </td>

//                           {/* <td>
//                             {/* <div className="flex">
//                           <button
//                             className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                             onClick={() => {
//                               setEditingBooking(b);
//                               setFormData({
//                                 ...b,
//                                 isPackageBooking: !!b.package, // ✅ tick checkbox if package exists
//                                 bookingtime: b.bookingtime
//                                   ? new Date(b.bookingtime).toISOString()
//                                   : new Date().toISOString(),
//                               });
//                                  setFormMode("view");
//                               setIsViewOnly(true); // ✅ enables read-only mode
//                               setIsOpen_popupForm(true);
//                             }}
//                           >
//                             <FaEye size={15} />
//                           </button>
//                           <button
//                             className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                             onClick={() => {
//                               setEditingBooking(b);
//                               setFormData({
//                                 ...b,
//                                 isPackageBooking: !!b.package,
//                                 bookingtime: b.bookingtime
//                                   ? new Date(b.bookingtime).toISOString()
//                                   : new Date().toISOString(),
//                               });
//                                setFormMode("edit");
//                               setIsViewOnly(false); // disable view-only mode
//                               setIsOpen_popupForm(true);
//                             }}
//                           >
//                             <FaEdit size={14} />
//                           </button>
//                           <button
//                             onClick={() =>
//                               setDeletePopup({ open: true, bookingid: b.id })
//                             }
//                             className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                           >
//                             <MdDelete size={15} />
//                           </button>
//                         </div>
//                             <div className="flex">
//                               {/* Everyone can view
//                               <button
//                                 className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                                 onClick={() => {
//                                   setEditingBooking(b);
//                                   setFormData({
//                                     ...b,
//                                     isPackageBooking: !!b.package,
//                                     bookingtime: b.bookingtime
//                                       ? new Date(b.bookingtime).toISOString()
//                                       : new Date().toISOString(),
//                                   });
//                                   setFormMode("view");
//                                   setIsViewOnly(true);
//                                   setIsOpen_popupForm(true);
//                                 }}
//                               >
//                                 <FaEye size={15} />
//                               </button>

//                               {/* Only admins can edit/delete
//                               {isAdmin && (
//                                 <>
//                                   <button
//                                     className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                                     onClick={() => {
//                                       setEditingBooking(b);
//                                       setFormData({
//                                         ...b,
//                                         isPackageBooking: !!b.package,
//                                         bookingtime: b.bookingtime
//                                           ? new Date(
//                                               b.bookingtime,
//                                             ).toISOString()
//                                           : new Date().toISOString(),
//                                       });
//                                       setFormMode("edit");
//                                       setIsViewOnly(false);
//                                       setIsOpen_popupForm(true);
//                                     }}
//                                   >
//                                     <FaEdit size={14} />
//                                   </button>

//                                   <button
//                                     onClick={() =>
//                                       setDeletePopup({
//                                         open: true,
//                                         bookingid: b.id,
//                                       })
//                                     }
//                                     className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125 transition-all"
//                                   >
//                                     <MdDelete size={15} />
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </td> */}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* Pagination */}
//                 <nav
//                   className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
//                   aria-label="Table navigation"
//                 >
//                   <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                     Showing{" "}
//                     <span className="font-semibold text-gray-700 dark:text-white">
//                       {indexOfFirstTable_booking + 1}-
//                       {Math.min(indexOfLastTable_booking, bookings.length)}
//                     </span>{" "}
//                     of{" "}
//                     <span className="font-semibold text-gray-700 dark:text-white">
//                       {bookings.length}
//                     </span>
//                   </span>

//                   <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                     <li>
//                       <button
//                         onClick={handlePrevPage_booking}
//                         disabled={currentPage_booking === 1}
//                         className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
//                       >
//                         <MdKeyboardDoubleArrowLeft />
//                       </button>
//                     </li>
//                     {generatePageNumbers_booking().map((page, index) =>
//                       page === "..." ? (
//                         <li
//                           key={index}
//                           className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7]"
//                         >
//                           <span>...</span>
//                         </li>
//                       ) : (
//                         <li key={index}>
//                           <button
//                             onClick={() => handlePageChange_booking(page)}
//                             className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
//                               currentPage_booking === page
//                                 ? "text-green-500 underline underline-offset-2"
//                                 : ""
//                             }`}
//                           >
//                             {page}
//                           </button>
//                         </li>
//                       ),
//                     )}
//                     <li>
//                       <button
//                         onClick={handleNextPage_booking}
//                         disabled={currentPage_booking === totalPages_booking}
//                         className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
//                       >
//                         <MdKeyboardDoubleArrowRight />
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </>
//             )}
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Bookings;
